<template>
	<div class="wrap">
		<div class="content">
			<div class="detail-page" v-if="item">
				<div class="detail-page--top">
					<div class="left">
						<div
							class="state"
							v-bind:class="{
								'bg-grey': item.sell_status == 'hold',
								'bg-lgrey': item.sell_status == 'ready',
								'bg-red': item.sell_status == 'sell',
							}"
						>
							<span class="date">{{ $dateFormat(item.reg_date) }}</span>
							<span class="date">
								<template v-if="item.sell_status == 'done'">
									{{ $dateFormat(item.done_date_time) }}
								</template>
								<template v-else>&nbsp;</template>
							</span>
							<p
								class="name"
								v-bind:class="{
									'text-secondary': item.sell_status == 'ready',
									'text-dark': item.sell_status == 'hold',
									'text-danger': item.sell_status == 'sell',
								}"
							>
								{{ $ITEM_STATE[item.sell_status] }}
							</p>
						</div>
					</div>
					<div class="info">
						<div class="top">
							<b-icon-journal-text /> 물건번호 : {{ item.building_uid }}
							<button
								type="button"
								class="btn btn-sm"
								v-bind:class="{ 'btn-primary': item.chk_status == 'A', 'btn-secondary': item.chk_status != 'A' }"
							>
								A
							</button>
							<button
								type="button"
								class="btn btn-sm"
								v-bind:class="{ 'btn-primary': item.chk_status == 'B', 'btn-secondary': item.chk_status != 'B' }"
							>
								B
							</button>
							<button
								type="button"
								class="btn btn-sm"
								v-bind:class="{ 'btn-primary': item.chk_status == 'C', 'btn-secondary': item.chk_status != 'C' }"
							>
								C
							</button>
						</div>
						<div class="bottom">{{ item.building_name }}</div>
					</div>
					<div class="count">
						<div class="box">
							조회
							<span class="num"
								><span class="txt-c--blue">{{ viewObj.today_view_cnt }}</span> / {{ viewObj.max_view_cnt }}</span
							>
						</div>
						<div class="box">
							출력
							<span class="num"
								><span class="txt-c--blue">{{ viewObj.today_print_cnt }}</span> / {{ viewObj.max_print_cnt }}</span
							>
						</div>
					</div>
					<div class="input-box">
						<!-- G-2: 담당자 좌측 (기존 종류 자리) — 좌우 반전 per spec -->
						<label class="label">담당자</label>
						<input
							type="text"
							class="form-control"
							:value="item.building_mem_name + ' ' + item.building_mem_rank_name"
							readonly
						/>

						<!-- G-2: 작업하기 UI 우측 — sell_status='done'(매물)/'sell'(매각) 일 때 완전히 숨김 -->
						<template v-if="!hideWorkUi">
							<span v-if="isWorkingActive" class="tag-shape tag-shape--working">
								작업기한 : {{ $dateFormat(item.working_edate) }}
							</span>
							<template v-else>
								<span class="tag-shape tag-shape--available">작업가능</span>
								<button
									type="button"
									class="btn btn-sm btn-primary"
									@click="btnStartWork"
									v-if="!$store.getters.getGuest"
								>
									작업하기
								</button>
							</template>
						</template>
					</div>
					<div class="page">
						<button type="button" class="btn first" @click="getTotal('first')"><b-icon-chevron-double-left /></button>
						<button type="button" class="btn prev" @click="getTotal('prev')"><b-icon-chevron-left /></button>
						<input type="text" class="form-control" v-model="searchInfo.idx" @keyup.enter="getTotal('sel_idx')" />
						&nbsp;&nbsp;/&nbsp;&nbsp;
						<input
							type="text"
							class="form-control"
							v-model="searchInfo.totalCount"
							disabled
							style="background-color: white"
						/>
						<button type="button" class="btn next" @click="getTotal('next')"><b-icon-chevron-right /></button>
						<button type="button" class="btn last" @click="getTotal('last')"><b-icon-chevron-double-right /></button>
					</div>
					<div class="right">
						<div class="top">
							<button type="button" class="btn btn-sm btn-outline-secondary" @click="isPopupShow2 = true">
								<b-icon-file-earmark />&nbsp;첨부파일
							</button>
							<button type="button" class="btn btn-sm btn-outline-secondary" @click="btnOnPrint">
								<b-icon-printer />&nbsp;출력
							</button>
							<button type="button" class="btn btn-sm btn-outline-secondary" @click="openPrintLogModal">
								<b-icon-list-ul />&nbsp;출력로그
							</button>
						</div>
						<div class="bottom">
							<button type="button" class="btn btn-sm btn-secondary" @click="goEdit" v-if="!$store.getters.getGuest">
								편집모드
							</button>
							<button
								v-if="$store.getters.getGuest && $store.getters.getInstitution"
								type="button"
								class="btn btn-sm btn-primary"
								@click="btnAddCart"
							>
								물건 담기
							</button>
							<template v-else>
								<!-- 매매검색의 '고객탭연결' 과 같은 고객 선택 창을 이 매물 한 건으로 연다. -->
								<button type="button" class="btn btn-sm btn-primary" @click="btnOnBriefing">브리핑대기물건저장</button>
								<!-- Weekly 는 사용 권한이 있는 직원에게만 보인다(DE: 기본은 팀장과 관리자). 판정은 getWeeklyBlocked 한 곳. -->
								<button
									v-if="!$store.getters.getGuest && !$store.getters.getWeeklyBlocked"
									type="button"
									class="btn btn-sm btn-primary"
									@click="openWeeklyPopup"
								>
									Weekly 저장
								</button>
							</template>
						</div>
					</div>
				</div>
				<div class="detail-page--con">
					<div class="left">
						<div class="con">
							<div class="tit">
								주소

								<button
									v-for="link in linkList"
									:key="'linL_' + link.bid"
									type="button"
									class="btn btn-xxsm btn-dark"
									@click="btnOnDetail2(link.bid)"
								>
									<b-icon-link-45deg />
									{{ link.building_name }}
								</button>

								<button type="button" class="btn btn-xxsm btn-secondary" @click="isPopupShow5 = true">
									<b-icon-filter-square-fill />
								</button>
								<button type="button" class="btn btn-xxsm btn-secondary" @click="btnOnDetail">지도검색</button>
								<button type="button" class="btn map2" @click.stop="$openDaumMap(item.jibun_addr)"></button>
								<button type="button" class="btn map1" @click.stop="$openNaverMap(item.jibun_addr)"></button>
								<button v-if="item.pt && item.pt.y && item.pt.x" type="button" class="btn map3" @click.stop="$openBlocMap(item.pt.y, item.pt.x, item.pnu_code)" title="블록지도"></button>
							</div>
							<div class="text">{{ jinbun_addr }}</div>
						</div>
						<div class="con">
							<div class="tit">
								금액정보
								<button type="button" class="btn icon" @click="$reloadPage()">
									<b-icon-arrow-repeat />
								</button>
							</div>
							<table class="table type-input">
								<colgroup>
									<col width="35%" />
									<col width="65%" />
								</colgroup>
								<!-- 입금가: 직원·제휴기관(신한/대신) 게스트는 노출, 일반 데모 게스트만 행 숨김.
								     백엔드 /admin/api/detail/item 의 institution 분기와 상보 관계(둘 다 고쳐야 값이 실림). -->
								<tr v-if="!$store.getters.getGuest || $store.getters.getPartnerGuest">
									<th>입금가</th>
									<td>{{ $formatMoney(item.ins_price, $MONEY_FORMAT_TYPE.LOAN) }}</td>
								</tr>
								<tr>
									<th>매매금액</th>
									<td class="txt-c--red">
										<template v-if="calcStatus[0]">
											{{ $formatMoney(Number(calcInfo.sell_price), $MONEY_FORMAT_TYPE.LOAN) }}
											<br />
											<money3
												style="text-align: right"
												class="form-control sm"
												v-model="calcInfo.sell_price"
												v-bind="$MONEY1"
												@change="chageCalc"
											></money3>
										</template>
										<template v-else>
											{{ $formatMoney(item.sell_price, $MONEY_FORMAT_TYPE.LOAN) }}
										</template>
										<button type="button" class="btn icon" @click="btnCalc(0)">
											<b-icon-pencil />
										</button>
									</td>
								</tr>
								<tr>
									<th>토지가격</th>
									<td>
										<template v-if="checkCalc()">
											{{ $formatMoney(Number(calcInfo.land_price), $MONEY_FORMAT_TYPE.LOAN) }} [평당
											{{ $formatMoney(Number(calcInfo.land_size_py_price), $MONEY_FORMAT_TYPE.LOAN) }}]
										</template>
										<template v-else>
											{{ $formatMoney(item.land_price, $MONEY_FORMAT_TYPE.LOAN) }} [평당
											{{ $formatMoney(item.land_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }}]
										</template>
									</td>
								</tr>
								<tr>
									<th>건물가격</th>
									<td>
										<template v-if="calcStatus[1]">
											{{ $formatMoney(Number(calcInfo.building_price), $MONEY_FORMAT_TYPE.LOAN) }} [평당
											{{ $formatMoney(Number(calcInfo.building_price_py_price), $MONEY_FORMAT_TYPE.LOAN) }}]
											<br />
											<money3
												style="text-align: right"
												class="form-control sm"
												v-model="calcInfo.building_price_py_price"
												v-bind="$MONEY1"
												@change="chageCalc"
											></money3>
										</template>
										<template v-else>
											{{ $formatMoney(item.building_price, $MONEY_FORMAT_TYPE.LOAN) }} [평당
											{{ $formatMoney(item.building_price_py_price, $MONEY_FORMAT_TYPE.LOAN) }}]
										</template>
										<button type="button" class="btn icon" @click="btnCalc(1)"><b-icon-pencil /></button>
									</td>
								</tr>
								<tr>
									<th>연면적 평당가격</th>
									<td>
										<template v-if="checkCalc()">
											{{ $formatMoney(Number(calcInfo.total_size_py_price), $MONEY_FORMAT_TYPE.LOAN) }}
										</template>
										<template v-else>
											{{ $formatMoney(item.total_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }}
										</template>
									</td>
								</tr>
							</table>
							<table class="table type-input mt-2">
								<colgroup>
									<col width="35%" />
									<col width="65%" />
								</colgroup>
								<tr>
									<th>보증금</th>
									<td>
										<template v-if="calcStatus[2]">
											{{ $formatMoney(Number(calcInfo.deposit), $MONEY_FORMAT_TYPE.LOAN) }}
											<br />
											<money3
												style="text-align: right"
												class="form-control sm"
												v-model="calcInfo.deposit"
												v-bind="$MONEY1"
												@change="chageCalc"
											></money3>
										</template>
										<template v-else>
											{{ $formatMoney(item.ex_sum_rent_deposit, $MONEY_FORMAT_TYPE.LOAN) }}
										</template>
										<button type="button" class="btn icon" @click="btnCalc(2)"><b-icon-pencil /></button>
									</td>
								</tr>
								<tr>
									<th>월임대료</th>
									<td>
										<template v-if="calcStatus[3]">
											{{ $formatMoney(Number(calcInfo.rent_money), $MONEY_FORMAT_TYPE.LOAN) }}
											<br />
											<money3
												style="text-align: right"
												class="form-control sm"
												v-model="calcInfo.rent_money"
												v-bind="$MONEY1"
												@change="chageCalc"
											></money3>
										</template>
										<template v-else>
											{{ $formatMoney(item.ex_sum_rent_money, $MONEY_FORMAT_TYPE.LOAN) }}
										</template>
										<button type="button" class="btn icon" @click="btnCalc(3)"><b-icon-pencil /></button>
									</td>
								</tr>
								<tr>
									<th>관리비</th>
									<td>
										<template v-if="calcStatus[4]">
											{{ $formatMoney(Number(calcInfo.mgr_fee), $MONEY_FORMAT_TYPE.LOAN) }}
											<br />
											<money3
												style="text-align: right"
												class="form-control sm"
												v-model="calcInfo.mgr_fee"
												v-bind="$MONEY1"
												@change="chageCalc"
											></money3>
										</template>
										<template v-else>
											{{ $formatMoney(item.ex_sum_mgr_fee, $MONEY_FORMAT_TYPE.LOAN) }}
										</template>
										<button type="button" class="btn icon" @click="btnCalc(4)"><b-icon-pencil /></button>
									</td>
								</tr>
								<tr>
									<th>관리비수입 / 지출</th>
									<td>
										<template v-if="calcStatus[4]">
											{{ $formatMoney(Number(calcInfo.mgr_fee), $MONEY_FORMAT_TYPE.LOAN) }} /
											{{ $formatMoney(Number(calcInfo.mgr_fee_out), $MONEY_FORMAT_TYPE.LOAN) }}
											<br />
											<money3
												style="text-align: right"
												class="form-control sm"
												v-model="calcInfo.mgr_fee"
												v-bind="$MONEY1"
												@change="chageCalc"
											></money3>
											/
											<money3
												style="text-align: right"
												class="form-control sm"
												v-model="calcInfo.mgr_fee_out"
												v-bind="$MONEY1"
												@change="chageCalc"
											></money3>
										</template>
										<template v-else>
											{{ $formatMoney(item.ex_sum_mgr_fee, $MONEY_FORMAT_TYPE.LOAN) }} /
											{{ $formatMoney(item.ex_sum_mgr_fee_out, $MONEY_FORMAT_TYPE.LOAN) }}
										</template>
										<button type="button" class="btn icon" @click="btnCalc(4)"><b-icon-pencil /></button>
									</td>
								</tr>
								<tr>
									<th>총수익</th>
									<td>
										<template v-if="checkCalc()">
											{{ $formatMoney(Number(calcInfo.total_income), $MONEY_FORMAT_TYPE.LOAN) }}
										</template>
										<template v-else>
											{{ $formatMoney(item.total_income, $MONEY_FORMAT_TYPE.LOAN) }}
										</template>
									</td>
								</tr>
								<tr>
									<th>수익률</th>
									<td>
										<template v-if="checkCalc()">
											<strong>{{ calcInfo.income_rate }}%</strong>
										</template>
										<template v-else>
											<strong>{{ item.total_income_rate }}%</strong>
										</template>
									</td>
								</tr>
							</table>
						</div>
						<div class="con">
							<div class="tit">토지정보</div>
							<table class="table type-input">
								<colgroup>
									<col width="35%" />
									<col width="65%" />
								</colgroup>
								<tr>
									<th>대지면적</th>
									<td>
										{{ $formatArea(item.land_size_m2) }}㎡ <strong>[{{ $formatArea(item.land_size_p) }}평]</strong>
									</td>
								</tr>
								<tr>
									<th>용도지역</th>
									<td>{{ item.cfg_val1 }}</td>
								</tr>
								<tr>
									<th>주변역/거리</th>
									<td>{{ item.substation }} [{{ item.substation_distance }}m]</td>
								</tr>
								<tr>
									<th>공시지가합계</th>
									<td>
										{{ $formatMoney(Number(item.public_land_price), $MONEY_FORMAT_TYPE.LOAN) }}
										[평당:{{ $formatMoney(Number(item.public_land_price_py_price), $MONEY_FORMAT_TYPE.LOAN) }}]<template v-if="item.public_land_price_year"> [ {{ item.public_land_price_year }}년 기준 ]</template>
									</td>
								</tr>
								<tr>
									<th>도로사항</th>
									<td>
										<template v-if="item.roadwide_1">{{ item.roadwide_1 }}m</template>
										<template v-if="item.roadwide_2">,{{ item.roadwide_2 }}m</template>
										<template v-if="item.roadwide_3">,{{ item.roadwide_3 }}m</template>
										<template v-if="item.roadwide_4">,{{ item.roadwide_4 }}m</template>
										<template v-if="item.chk_road_coner == 'Y'">,코너</template>
										<template v-if="item.chk_road_dual == 'Y'">,양면</template>
										<br />
										<template v-if="item.road_name">[{{ item.road_name }}]</template>
									</td>
								</tr>
							</table>
						</div>
						<div class="con">
							<div class="tit">건축물정보</div>
							<table class="table type-input">
								<colgroup>
									<col width="35%" />
									<col width="65%" />
								</colgroup>
								<tr>
									<th>연면적</th>
									<td>
										{{ $formatArea(item.total_size_m2) }}㎡ <strong>[{{ $formatArea(item.total_size_p) }}평]</strong>
									</td>
								</tr>
								<tr>
									<th>건축면적</th>
									<td>{{ $formatArea(item.build_size_m2) }}㎡ [{{ $formatArea(item.build_size_p) }}평]</td>
								</tr>
								<tr>
									<th>규모</th>
									<td>{{ $getFloorString(this.item.floor_cnt_B, this.item.floor_cnt_F) }}</td>
									<!-- 철근콘크리트구조 추가 해야함 -->
								</tr>
								<tr>
									<th>준공연도/리모델링</th>
									<td>
										{{ $dateFormat(this.item.build_date) }}
										<template v-if="$dateFormat(this.item.remodel_date)">
											/ {{ $dateFormat(this.item.remodel_date) }}
										</template>
									</td>
								</tr>
								<tr>
									<th>건폐율/용적률</th>
									<td>{{ $formatRatio(item.bl_ratio) }}/{{ $formatRatio(item.fa_ratio) }}</td>
								</tr>
								<tr>
									<th>주차방식/대수</th>
									<td>
										<template v-if="item.park_type_name">{{ item.park_type_name }} /</template>
										법정 {{ item.park_cnt_law }}대 / 실제 {{ item.park_cnt_real }}대
									</td>
								</tr>
								<tr>
									<th>냉/난방식</th>
									<td>{{ item.heat_type_name }}</td>
								</tr>
								<tr>
									<th>승강기</th>
									<td>{{ item.ev_cnt }}대</td>
								</tr>
							</table>
						</div>
						<div class="con">
							<div class="tit">
								소유권/토지 (K-GeoP)
								<button type="button" class="btn btn-xxsm btn-secondary" :disabled="kgeopLoading" @click="getKGeop">{{ kgeopLoading ? '조회중…' : '조회' }}</button>
							</div>
							<table v-if="kgeop" class="table type-input">
								<colgroup>
									<col width="35%" />
									<col width="65%" />
								</colgroup>
								<tr>
									<th>소유구분</th>
									<td>{{ kgeop.land.owner_type || '-' }}</td>
								</tr>
								<tr>
									<th>소유자</th>
									<td>
										{{ kgeop.land.owner_name || '-' }}
										<template v-if="kgeop.land.owner_masked"> <small style="color:#999;">(개인 · 마스킹)</small></template>
										<template v-if="kgeop.land.owner_regno && !kgeop.land.owner_masked"> / {{ kgeop.land.owner_regno }}</template>
									</td>
								</tr>
								<tr v-if="Number(kgeop.land.co_owners) > 0">
									<th>공유인수</th>
									<td>{{ kgeop.land.co_owners }}명</td>
								</tr>
								<tr v-if="kgeop.land.owner_addr">
									<th>소유자주소</th>
									<td>{{ kgeop.land.owner_addr }}</td>
								</tr>
								<tr v-if="kgeop.land.change_date">
									<th>최근변동</th>
									<td>{{ kgeop.land.change_date }}<template v-if="kgeop.land.change_reason"> ({{ kgeop.land.change_reason }})</template></td>
								</tr>
								<tr>
									<th>지목/면적</th>
									<td>{{ kgeop.land.jimok || '-' }} / {{ kgeop.land.area_m2 || '-' }}㎡</td>
								</tr>
								<tr v-if="kgeop.jiga.price">
									<th>개별공시지가</th>
									<td>{{ kgeop.jiga.price }}원/㎡<template v-if="kgeop.jiga.base_date"> [{{ kgeop.jiga.base_date }}]</template></td>
								</tr>
								<tr v-if="kgeop.apt_price">
									<th>공동주택공시가격</th>
									<td>{{ kgeop.apt_price.sample.price }}원 (전용 {{ kgeop.apt_price.sample.area_m2 }}㎡, {{ kgeop.apt_price.sample.base_date }})<br />{{ kgeop.apt_price.danji }} 외 {{ kgeop.apt_price.count }}건</td>
								</tr>
								<tr v-if="kgeop.owner_history && kgeop.owner_history.length">
									<th>소유권변동연혁</th>
									<td>
										<div v-for="(h, i) in kgeop.owner_history" :key="i" style="font-size:12px; padding:1px 0;">{{ h.date }} · {{ h.reason }} · {{ h.owner_type }} · {{ h.owner_name }}<template v-if="Number(h.co_owners) > 0"> ({{ h.co_owners }}명)</template><template v-if="h.owner_addr"> · {{ h.owner_addr }}</template></div>
									</td>
								</tr>
							</table>
							<div v-else class="text" style="font-size:12px; color:#888;">버튼을 눌러 한국국토정보공사(K-GeoP) 토지·소유권 정보를 조회합니다.<br />개인 소유자명·등록번호는 마스킹되어 표시됩니다.</div>
						</div>
						<div class="con">
							<div class="tit">대출/비용계산기</div>
							<table class="table type-input">
								<colgroup>
									<col width="18%" />
									<col width="32%" />
									<col width="18%" />
									<col width="32%" />
								</colgroup>
								<tr>
									<th>대출금액</th>
									<td>
										<money3 class="form-control sm" v-model="calcInfo.loan_money" v-bind="$MONEY1"></money3>
										<span>&nbsp;만&nbsp;</span>
									</td>
									<th>대출금리</th>
									<td>
										<money3 class="form-control sm" v-model="calcInfo.loan_rate" v-bind="$MONEY2"></money3>
										<span>&nbsp;%&nbsp;</span>
									</td>
								</tr>
							</table>
							<div class="text-center m-2">
								<button type="button" class="btn btn-xxsm btn-secondary" @click="calcLoan">계산하기</button>
							</div>
							<table class="table type-input">
								<colgroup>
									<col width="18%" />
									<col width="32%" />
									<col width="18%" />
									<col width="32%" />
								</colgroup>
								<tr>
									<th>연이자액</th>
									<td>
										<money3
											class="form-control sm"
											v-model="calcInfo.year_loan_money"
											v-bind="$MONEY1"
											readonly
										></money3>
										<span>&nbsp;만&nbsp;</span>
									</td>
									<th>
										구입자금
										<span class="tooltip-wrap">
											<span class="tooltip-btn">?</span>
											<span class="tooltip-con">매매금액에서 보증금과 대출금액을 뺀 값입니다.</span>
										</span>
									</th>
									<td>
										<money3 class="form-control sm" v-model="calcInfo.buy_money" v-bind="$MONEY1" readonly></money3>
										<span>&nbsp;만&nbsp;</span>
									</td>
								</tr>
								<tr>
									<th>월이자액</th>
									<td>
										<money3
											class="form-control sm"
											v-model="calcInfo.month_loan_money"
											v-bind="$MONEY1"
											readonly
										></money3>
										<span>&nbsp;만&nbsp;</span>
									</td>
									<th>
										대부비율
										<span class="tooltip-wrap">
											<span class="tooltip-btn">?</span>
											<span class="tooltip-con">매매금액에 대한 대출금액의 비율입니다.</span>
										</span>
									</th>
									<td>
										<money3
											class="form-control sm"
											v-model="calcInfo.loan_buy_money_per"
											v-bind="$MONEY2"
											readonly
										></money3>
										<span>&nbsp;%&nbsp;</span>
									</td>
								</tr>
								<tr>
									<th>
										월순수입
										<span class="tooltip-wrap">
											<span class="tooltip-btn">?</span>
											<span class="tooltip-con">월총수익에서 월이자액을 뺀 값입니다.</span>
										</span>
									</th>
									<td>
										<money3
											class="form-control sm"
											v-model="calcInfo.month_earn_money"
											v-bind="$MONEY1"
											readonly
										></money3>
										<span>&nbsp;만&nbsp;</span>
									</td>
									<th>
										레버리지
										<span class="tooltip-wrap">
											<span class="tooltip-btn">?</span>
											<span class="tooltip-con">총수익에서 금융비용을 제한 값을 자기자본으로 나눈 값입니다.</span>
										</span>
									</th>
									<td>
										<money3
											class="form-control sm"
											v-model="calcInfo.leverage_earn_rate"
											v-bind="$MONEY2"
											readonly
										></money3>
										<span>&nbsp;%&nbsp;</span>
									</td>
								</tr>
							</table>
							<p class="txt-size--sm mt-1">
								※ 간단한 대출정보 계산기입니다. 실제 대출 정보와는 다소 차이가 있을 수 있습니다.
							</p>
						</div>
					</div>
					<div class="center">
						<div class="con">
							<div class="tit">특징</div>
							<div class="feature">
								<div class="left">
									<template v-if="imgSt">
										<swiper :pagination="true" :autoHeight="true" :zoom="true" :modules="modules">
											<swiper-slide v-for="(item, idx) in imgList" :key="'iiimmg_' + idx">
												<div class="swiper-zoom-container">
													<img :src="item" alt="" style="max-width: 384px; max-height: 500px" />
												</div>
											</swiper-slide>
										</swiper>
									</template>
									<template v-else>
										<div v-show="!panoFailed" id="pano" style="width: 100%; height: 500px"></div>
										<div v-if="panoFailed" class="pano-fallback" style="width: 100%; height: 500px; display: flex; align-items: center; justify-content: center; color: #888; background: #f5f5f5">거리뷰를 불러올 수 없습니다</div>
									</template>
								</div>
								<!-- F-4.1: @wheel.prevent stops the browser from scrolling the page
								     while the user is zooming the Naver map with the mouse wheel,
								     preventing the map from jumping to unrelated areas. -->
								<div class="right" @wheel.prevent>
									<div id="map" style="touch-action: none;"></div>
								</div>
							</div>
							<div class="text" v-html="item.memo.split('\n').join('<br />')"></div>
						</div>
						<!-- 블록(bloc.ai.kr) 노출 (CN) —————————————————————————————————————
						     매물을 회사 밖 공개 사이트로 내보내는 스위치다. 기본은 꺼짐이고,
						     담당자가 켠 매물만 나간다. 켜는 순간 실제로 전송하고 결과를 여기 보여 준다.
						     게스트(데모·제휴)는 이 패널 자체를 보지 못한다(서버도 /bloc 경로를 막는다). -->
						<div class="con" v-if="!$store.getters.getGuest">
							<div class="tit">
								블록 노출
								<span class="bloc-state" :class="'st-' + (blocLink.syncState || 'none')">{{ blocStateLabel }}</span>
								<button type="button" class="btn btn-xxsm btn-secondary" :disabled="blocBusy" @click="loadBloc">새로고침</button>
							</div>

							<div class="bloc-box" v-if="blocLoaded">
								<div class="bloc-warn" v-if="!blocConfigured">
									블록 연동이 아직 설정되지 않았습니다. {{ blocConfigError }}
								</div>
								<div class="bloc-warn" v-else-if="!blocExposable && blocForm.expose !== 'Y'">
									{{ blocExposableReason }}
								</div>
								<div class="bloc-warn" v-if="blocLink.autoOffReason">
									{{ blocAutoOffLabel }} 다시 내보내려면 아래에서 켜 주세요.
								</div>
								<div class="bloc-err" v-if="blocLink.syncError">
									마지막 전송 실패: {{ blocLink.syncError }}
								</div>

								<label class="bloc-toggle">
									<input type="checkbox" v-model="blocExposeOn" :disabled="blocBusy || !blocConfigured || (!blocExposable && !blocExposeOn)" />
									이 매물을 블록에 내보내기
								</label>

								<div class="bloc-grade" v-if="blocExposeOn">
									<label :class="{ on: blocForm.visibility === 'public' }">
										<input type="radio" value="public" v-model="blocForm.visibility" :disabled="blocBusy" />
										공개
										<em>블록 지도·목록에서 누구나 봅니다</em>
									</label>
									<label :class="{ on: blocForm.visibility === 'hidden' }">
										<input type="radio" value="hidden" v-model="blocForm.visibility" :disabled="blocBusy" />
										히든매물
										<em>블록 로그인 어드민에게만 보입니다</em>
									</label>
								</div>

								<!-- 매물 특징은 사내 메모라 따로 켠다. Weekly 리포트와 같은 규칙이다. -->
								<div class="bloc-feat" v-if="blocExposeOn && blocPreview.featureLines.length">
									<label class="bloc-toggle">
										<input type="checkbox" v-model="blocFeatOn" :disabled="blocBusy" />
										매물 특징도 함께 내보내기
									</label>
									<div class="bloc-warn" v-if="!blocFeatOn">
										아래는 사내 메모라 매도인 사정·과거 매각가 같은 협상 정보가 섞여 있을 수 있습니다.
										내용을 확인하신 뒤 켜 주세요.
									</div>
									<ul class="bloc-feat-list" :class="{ off: !blocFeatOn }">
										<li v-for="(line, i) in blocPreview.featureLines" :key="'blf_' + i">{{ line }}</li>
									</ul>
								</div>

								<div class="bloc-meta">
									<span>사진 {{ blocPreview.imageCount }}장</span>
									<span v-if="blocLink.lastPushedAt">마지막 전송 {{ blocLink.lastPushedAt }}</span>
								</div>

								<div class="bloc-actions">
									<button type="button" class="btn btn-sm btn-primary" :disabled="blocBusy || !blocConfigured || blocDirty === false" @click="saveBloc">
										{{ blocBusy ? '처리중…' : '적용' }}
									</button>
									<button type="button" class="btn btn-sm btn-secondary" v-if="blocLink.expose === 'Y'" :disabled="blocBusy" @click="resyncBloc">
										다시 보내기
									</button>
									<button type="button" class="btn btn-sm btn-secondary" v-if="blocLink.blocPropertyId" @click="openBlocProperty">
										블록에서 보기
									</button>
								</div>
							</div>
							<div class="bloc-box" v-else>불러오는 중…</div>
						</div>
						<div class="con">
							<div class="tab-btn">
								<button
									type="button"
									class="btn tab"
									v-bind:class="{ active: typeTab1 == false }"
									@click="typeTab1 = false"
								>
									임대차내역
								</button>
								<button
									type="button"
									class="btn tab"
									v-bind:class="{ active: typeTab1 == true }"
									@click="typeTab1 = true"
								>
									건축물대장
								</button>
							</div>
							<div class="tab-con">
								<table v-if="typeTab1 == false" class="table type-input">
									<tr>
										<th>층</th>
										<th>임대</th>
										<th>용도</th>
										<th>보증금</th>
										<th>월세</th>
										<th>관리비</th>
										<th>만기</th>
										<th>비고</th>
										<th>평당임대료</th>
									</tr>
									<tr :key="'rent_' + rent.building_rent_uid" v-for="rent in rentList" :class="{ 'rent-excluded': rent.except_flag === 'Y' }">
										<td class="text-center">{{ rent.rent_floor }}</td>
										<td class="text-center">{{ $formatArea(rent.rent_size_p) }}</td>
										<td class="text-center">{{ rent.rent_usage }}</td>
										<td class="text-center">{{ $formatNumber(rent.rent_deposit) }}</td>
										<td class="text-center">{{ $formatNumber(rent.rent_money) }}</td>
										<td class="text-center">{{ $formatNumber(rent.mgr_fee) }}</td>
										<td class="text-center">{{ rent.end_date }}</td>
										<td class="text-center">{{ rent.memo }}</td>
										<td class="text-center">{{ $formatNumber(rent.rent_ni) }}</td>
										<!-- except_flag -->
									</tr>
									<tr v-if="rentList.length > 0" class="bg-blue">
										<td class="text-center"><strong>합계</strong></td>
										<td class="text-center">{{ $formatArea(totalRentData.py) }}</td>
										<td class="text-center"></td>
										<td class="text-center">{{ $formatNumber(totalRentData.deposit) }}</td>
										<td class="text-center">{{ $formatNumber(totalRentData.money) }}</td>
										<td class="text-center">{{ $formatNumber(totalRentData.mgr) }}</td>
										<td class="text-center"></td>
										<td class="text-center"></td>
										<td class="text-center"></td>
									</tr>
								</table>
								<table v-else class="table type-input">
									<tr>
										<th>층</th>
										<th>면적</th>
										<th>평수</th>
										<th>층별용도</th>
									</tr>
									<tr :key="'floor_' + floor.building_floor_uid" v-for="floor in floorList" :class="{ 'floor-excluded': floor.chk_except === 'Y' }">
										<td class="text-center">{{ floor.flrNoNm }}</td>
										<td class="text-center">{{ $formatArea(floor.area_m2) }}</td>
										<td class="text-center">{{ $formatArea(floor.area_py) }}</td>
										<td class="text-center">{{ floor.name }}</td>
										<!-- chk_except -->
									</tr>
									<tr v-if="floorList.length > 0" class="bg-blue">
										<td class="text-center"><strong>합계</strong></td>
										<td class="text-center">{{ $formatArea(totalFloorData.m2) }}</td>
										<td class="text-center">{{ $formatArea(totalFloorData.py) }}</td>
										<td class="text-center"></td>
									</tr>
								</table>
							</div>
						</div>
					</div>
					<div v-if="!$store.getters.getGuest" class="right">
						<div class="con">
							<div class="tab-btn">
								<button
									type="button"
									class="btn tab"
									v-bind:class="{ active: typeTab3 == false }"
									@click="typeTab3 = false"
								>
									소유자정보
								</button>
								<button
									type="button"
									class="btn tab"
									v-bind:class="{ active: typeTab3 == true }"
									@click="typeTab3 = true"
								>
									전소유자
								</button>
							</div>
							<div class="tab-con">
								<table v-if="typeTab3 == false" class="table type-input">
									<colgroup>
										<col width="35%" />
										<col width="65%" />
									</colgroup>
									<tr>
										<th>성명</th>
										<td>{{ item.owner_name }}</td>
									</tr>
									<tr>
										<th>연락처</th>
										<td>
											<template v-if="memType || phoneView">
												{{ item.owner_home_phone }}
												<template v-if="item.owner_home_phone_memo">({{ item.owner_home_phone_memo }})</template>
											</template>
											<template v-else>
												xxx
												<button type="button" class="btn icon" @click="isPopupShow1 = true">
													<b-icon-search />
												</button>
											</template>
										</td>
									</tr>
									<tr>
										<th>연락처</th>
										<td>
											<template v-if="memType || phoneView">
												{{ item.owner_office_phone }}
												<template v-if="item.owner_office_phone_memo">({{ item.owner_office_phone_memo }})</template>
											</template>
											<template v-else>
												xxx
												<button type="button" class="btn icon" @click="isPopupShow1 = true">
													<b-icon-search />
												</button>
											</template>
										</td>
									</tr>
									<tr>
										<th>연락처</th>
										<td>
											<template v-if="memType || phoneView">
												{{ item.owner_mobile_1 }}
												<template v-if="item.owner_mobile_1_memo">({{ item.owner_mobile_1_memo }})</template>
											</template>
											<template v-else>
												xxx
												<button type="button" class="btn icon" @click="isPopupShow1 = true">
													<b-icon-search />
												</button>
											</template>
										</td>
									</tr>
								</table>
								<table v-else class="table type-input">
									<colgroup>
										<col width="35%" />
										<col width="65%" />
									</colgroup>
									<tr>
										<th>성명</th>
										<td>{{ item.pre_owner_name }}</td>
									</tr>
									<tr>
										<th>연락처</th>
										<td>
											<template v-if="memType || phoneView">
												{{ item.pre_owner_home_phone }}
												<template v-if="item.pre_owner_home_phone_memo"
													>({{ item.pre_owner_home_phone_memo }})</template
												>
											</template>
											<template v-else>
												xxx
												<button type="button" class="btn icon" @click="isPopupShow1 = true">
													<b-icon-search />
												</button>
											</template>
										</td>
									</tr>
									<tr>
										<th>연락처</th>
										<td>
											<template v-if="memType || phoneView">
												{{ item.pre_owner_office_phone }}
												<template v-if="item.pre_owner_office_phone_memo"
													>({{ item.pre_owner_office_phone_memo }})</template
												>
											</template>
											<template v-else>
												xxx
												<button type="button" class="btn icon" @click="isPopupShow1 = true">
													<b-icon-search />
												</button>
											</template>
										</td>
									</tr>
									<tr>
										<th>연락처</th>
										<td>
											<template v-if="memType || phoneView">
												{{ item.pre_owner_mobile_1 }}
												<template v-if="item.pre_owner_mobile_1_memo">({{ item.pre_owner_mobile_1_memo }})</template>
											</template>
											<template v-else>
												xxx
												<button type="button" class="btn icon" @click="isPopupShow1 = true">
													<b-icon-search />
												</button>
											</template>
										</td>
									</tr>
								</table>
								<div class="text mt-2">
									<div v-html="item.owner_memo.split('\n').join('<br />')"></div>
								</div>
							</div>
						</div>
						<div class="con">
							<div class="tab-btn">
								<button
									type="button"
									class="btn tab"
									v-bind:class="{ active: typeTab2 == false }"
									@click="typeTab2 = false"
								>
									작업내역
								</button>
								<button
									type="button"
									class="btn tab"
									v-bind:class="{ active: typeTab2 == true }"
									@click="typeTab2 = true"
								>
									변경내역
								</button>
							</div>
							<div v-if="typeTab2 == false" class="tab-con">
								<div class="input-top">
									<select v-model="searchOptions.type" class="form-control select">
										<option v-for="c in clientTypeList" :key="'clienttype_' + c.ind_cfg_uid" :value="c.ind_cfg_uid">
											{{ c.name }}
										</option>
									</select>
									<input type="text" class="form-control" v-model="searchOptions.keyword" @keyup.enter="addClientLog" />
									<label v-if="isCallType()" class="input-checkbox" style="margin-left: 8px; white-space: nowrap" title="받지 않은 전화는 KPI 에 넣지 않고 부재로 따로 셉니다">
										<input type="checkbox" v-model="searchOptions.missed" />
										<span class="checkbox"></span>
										<span class="text">부재</span>
									</label>
								</div>
								<table class="table type-input">
									<colgroup>
										<col width="35%" />
										<col width="65%" />
									</colgroup>
									<tr>
										<th>일시</th>
										<th>구분</th>
										<th>작업자</th>
									</tr>
									<!-- 작업시작·담당자 변경·고객상담을 날짜 내림차순으로 통합 렌더 -->
									<template v-for="entry in combinedWorkList" :key="entry.key">
										<template v-if="entry.kind === 'work'">
											<tr class="work-row">
												<td>
													<strong>
														{{ $dateToFormat(entry.date, 'YYYY-MM-DD') }}
														<span style="color: #65af7e">{{ $dateToFormat(entry.date, 'ddd') }}</span>
														{{ $dateToFormat(entry.date, 'hh:mm') }}
													</strong>
												</td>
												<td>{{ entry.label }}</td>
												<td>{{ entry.doer }}</td>
											</tr>
											<tr class="work-row">
												<td colspan="3">{{ entry.desc }}</td>
											</tr>
										</template>
										<template v-else-if="entry.kind === 'client'">
											<tr>
												<td v-bind:class="{ 'tr-counsel-color': entry.log.counsel_type_name == '지시' }">
													<strong>
														{{ $dateToFormat(entry.date, 'YYYY-MM-DD') }}
														<span style="color: #65af7e">{{ $dateToFormat(entry.date, 'ddd') }}</span>
														{{ $dateToFormat(entry.date, 'hh:mm') }}
													</strong>
												</td>
												<td v-bind:class="{ 'tr-counsel-color': entry.log.counsel_type_name == '지시' }">
													{{ entry.log.counsel_type_name }}<span v-if="entry.log.call_result === 'missed'" class="txt-c--red"> (부재)</span>
												</td>
												<td v-bind:class="{ 'tr-counsel-color': entry.log.counsel_type_name == '지시' }">{{ entry.log.mem_name }}</td>
											</tr>
											<tr>
												<td v-bind:class="{ 'tr-counsel-color': entry.log.counsel_type_name == '지시' }" colspan="3">
													{{ entry.log.memo }}
													<button
														v-if="$store.getters.getUserInfo.mem_type == 'master'"
														type="button"
														class="btn icon red"
														@click="btnClientLogDel(entry.log.client_log_uid)"
													>
														<b-icon-trash />
													</button>
												</td>
											</tr>
										</template>
									</template>
								</table>
							</div>
							<div v-else class="tab-con">
								<table class="table type-input">
									<colgroup>
										<col width="35%" />
										<col width="65%" />
									</colgroup>
									<tr>
										<th>일시</th>
										<th>구분</th>
										<th>작업자</th>
									</tr>
									<template :key="'mgrlog_' + log.mgr_log_uid" v-for="log in filteredMgrLogList">
										<tr :class="{ 'work-row': log.sub_type_key === 'building_mem_uid' }">
											<td>
												<strong>
													{{ $dateToFormat(log.date, 'YYYY-MM-DD') }}
													<span style="color: #65af7e">{{ $dateToFormat(log.date, 'ddd') }}</span>
													{{ $dateToFormat(log.date, 'hh:mm') }}
												</strong>
											</td>
											<td>{{ $LOG_CHG_INFO[log.sub_type_key] }}</td>
											<td>{{ log.mem_name }}</td>
										</tr>
										<tr :class="{ 'work-row': log.sub_type_key === 'building_mem_uid' }">
											<td colspan="3">
												<template v-if="$LOG_CHG_INFO[log.sub_type_key] == $LOG_CHG_INFO.owner_info && !memType">
													xxx
												</template>
												<template v-else>
													{{ log.memo }}
												</template>
												<button
													v-if="$store.getters.getUserInfo.mem_type == 'master'"
													type="button"
													class="btn icon red"
													@click="btnMgrLogDel(log.mgr_log_uid)"
												>
													<b-icon-trash />
												</button>
											</td>
										</tr>
									</template>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isPopupShow1" class="popup-wrap">
			<div class="dim" @click="isPopupShow1 = false"></div>
			<div class="popup sm">
				<div class="popup-tit">
					소유자정보확인
					<button type="button" class="btn btn-close" @click="isPopupShow1 = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<table class="table type-input">
						<tr>
							<th>조회사유</th>
							<td>
								<select class="form-control select" v-model="popupData.selectData">
									<option value="" selected>선택</option>
									<option v-for="(i, idx) in $CLIENT_PHONE_REASON" :key="'sdf_' + idx">{{ i }}</option>
								</select>
								<div class="form-wrap" v-if="popupData.selectData == '직접입력'">
									<input class="form-control" type="text" v-model="popupData.data" />
								</div>
							</td>
						</tr>
						<tr>
							<th>비밀번호</th>
							<td>
								<div class="form-wrap">
									<input
										class="form-control"
										type="password"
										placeholder="비밀번호를 입력하세요."
										v-model="popupData.passwd"
									/>
								</div>
							</td>
						</tr>
					</table>
					<div class="btn-wrap mt-3">
						<button type="button" class="btn btn-md btn-primary" @click="sendPhone">확인</button>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isPopupShow2" class="popup-wrap">
			<div class="dim" @click="isPopupShow2 = false"></div>
			<div class="popup sm">
				<div class="popup-tit">
					첨부파일
					<button type="button" class="btn btn-close" @click="isPopupShow2 = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<table class="table">
						<colgroup>
							<col width="10%" />
							<col width="45%" />
							<col width="45%" />
						</colgroup>
						<tr>
							<th>번호</th>
							<th>파일명</th>
							<th>다운로드</th>
						</tr>
						<tr v-for="(f, idx) in fileList" :key="'fff_' + f.id">
							<td>{{ idx + 1 }}</td>
							<td>
								{{ f.usr_name }}
							</td>
							<td>
								<button type="button" class="btn btn-xsm btn-light" @click="downFile(f.id, f)">
									<b-icon-download />{{ f.org_name }}
								</button>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		<div v-if="isPopupShow5" class="popup-wrap">
			<div class="dim" @click="isPopupShow5 = false"></div>
			<div class="popup md">
				<div class="popup-tit">
					연결물건합계
					<button type="button" class="btn btn-close" @click="isPopupShow5 = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<div class="popup-con">
						<table class="table">
							<colgroup>
								<col width="8%" />
								<col width="12%" />
								<col width="30%" />
								<col width="30%" />
								<col width="20%" />
							</colgroup>
							<tr>
								<th colspan="2">물건명</th>
								<th v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">{{ it.building_name }}</th>
								<th rowspan="2">합계</th>
							</tr>
							<tr>
								<th colspan="2">주소</th>
								<th v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">{{ it.jibun_addr }}</th>
							</tr>
							<tr>
								<th rowspan="11">금액정보</th>
								<th>매매금액</th>
								<td class="txt-c--red" v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.sell_price), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue txt-c--red">
									{{ $formatMoney(linkSumObj.sum_sell_price, $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
							</tr>
							<tr>
								<th>토지가격</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.land_price), $MONEY_FORMAT_TYPE.LOAN) }}(평당
									{{ $formatMoney(Number(it.land_size_py_price), $MONEY_FORMAT_TYPE.LOAN) }})
								</td>
								<td class="bg-blue">
									{{ $formatMoney(linkSumObj.sum_land_price, $MONEY_FORMAT_TYPE.LOAN) }}(평당
									{{ $formatMoney(linkSumObj.sum_land_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }})
								</td>
							</tr>
							<tr>
								<th>건물가격</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.building_price), $MONEY_FORMAT_TYPE.LOAN) }}(평당
									{{ $formatMoney(Number(it.building_price_py_price), $MONEY_FORMAT_TYPE.LOAN) }})
								</td>
								<td class="bg-blue">
									{{ $formatMoney(linkSumObj.sum_building_price, $MONEY_FORMAT_TYPE.LOAN) }}(평당
									{{ $formatMoney(linkSumObj.sum_building_price_py_price, $MONEY_FORMAT_TYPE.LOAN) }})
								</td>
							</tr>
							<tr>
								<th>연면적평당가격</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.total_size_py_price), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue">{{ $formatMoney(linkSumObj.sum_total_size_py_price, $MONEY_FORMAT_TYPE.LOAN) }}</td>
							</tr>
							<tr>
								<th>보증금</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.ex_sum_rent_deposit), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue">{{ $formatMoney(linkSumObj.sum_ex_sum_rent_deposit, $MONEY_FORMAT_TYPE.LOAN) }}</td>
							</tr>
							<tr>
								<th>월임대료</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.ex_sum_rent_money), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue">{{ $formatMoney(linkSumObj.sum_ex_sum_rent_money, $MONEY_FORMAT_TYPE.LOAN) }}</td>
							</tr>
							<tr>
								<th>관리비</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.ex_sum_mgr_fee), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue">{{ $formatMoney(linkSumObj.sum_ex_sum_mgr_fee, $MONEY_FORMAT_TYPE.LOAN) }}</td>
							</tr>
							<tr>
								<th>관리비수입</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.ex_sum_mgr_fee), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue">{{ $formatMoney(linkSumObj.sum_ex_sum_mgr_fee, $MONEY_FORMAT_TYPE.LOAN) }}</td>
							</tr>
							<tr>
								<th>관리비지출</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.ex_sum_mgr_fee_out), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue">{{ $formatMoney(linkSumObj.sum_ex_sum_mgr_fee_out, $MONEY_FORMAT_TYPE.LOAN) }}</td>
							</tr>
							<tr>
								<th>총수익</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.total_income), $MONEY_FORMAT_TYPE.LOAN) }}
								</td>
								<td class="bg-blue">{{ $formatMoney(linkSumObj.sum_total_income, $MONEY_FORMAT_TYPE.LOAN) }}</td>
							</tr>
							<tr>
								<th>수익률</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">{{ it.total_income_rate }}%</td>
								<td class="bg-blue">{{ linkSumObj.sum_total_income_rate }}%</td>
							</tr>
							<tr>
								<th rowspan="2">토지정보</th>
								<th>대지면적</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatArea(it.land_size_m2) }}㎡ <strong>[{{ $formatArea(it.land_size_p) }}평]</strong>
								</td>
								<td class="bg-blue">
									{{ $formatArea(linkSumObj.sum_land_size_m2) }}㎡
									<strong>[{{ $formatArea(linkSumObj.sum_land_size_p) }}평]</strong>
								</td>
							</tr>
							<tr>
								<th>공시지가합계</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatMoney(Number(it.public_land_price), $MONEY_FORMAT_TYPE.LOAN) }}(평당
									{{ $formatMoney(Number(it.public_land_price_py_price), $MONEY_FORMAT_TYPE.LOAN) }})
								</td>
								<td class="bg-blue">
									{{ $formatMoney(linkSumObj.sum_public_land_price, $MONEY_FORMAT_TYPE.LOAN) }}(평당
									{{ $formatMoney(linkSumObj.sum_public_land_price_py_price, $MONEY_FORMAT_TYPE.LOAN) }})
								</td>
							</tr>
							<tr>
								<th rowspan="2">건축물정보</th>
								<th>연면적</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatArea(it.total_size_m2) }}㎡ <strong>[{{ $formatArea(it.total_size_p) }}평]</strong>
								</td>
								<td class="bg-blue">
									{{ $formatArea(linkSumObj.sum_total_size_m2) }}㎡
									<strong>[{{ $formatArea(linkSumObj.sum_total_size_p) }}평]</strong>
								</td>
							</tr>
							<tr>
								<th>건축면적</th>
								<td v-for="(it, idx) in linkSumObj.itemList" :key="'t_1_' + idx">
									{{ $formatArea(it.build_size_m2) }}㎡ <strong>[{{ $formatArea(it.build_size_p) }}평]</strong>
								</td>
								<td class="bg-blue">
									{{ $formatArea(linkSumObj.sum_build_size_m2) }}㎡
									<strong>[{{ $formatArea(linkSumObj.sum_build_size_p) }}평]</strong>
								</td>
							</tr>
						</table>
						<div class="btn-wrap mt-3">
							<button type="button" class="btn btn-md btn-primary" @click="isPopupShow5 = false">확인</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Weekly 저장: 이 매물을 내가 고칠 수 있는 Weekly 에 담거나 뺀다. 담은 매물은 리포트 맨 뒤에 붙는다. -->
		<div v-if="isWeeklyPopupShow" class="popup-wrap">
			<div class="dim" @click="isWeeklyPopupShow = false"></div>
			<div class="popup md">
				<div class="popup-tit">
					Weekly 저장
					<button type="button" class="btn btn-close" @click="isWeeklyPopupShow = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con wk-pick">
					<p class="wk-pick__lead">
						담을 물건 <b>{{ bid }}</b> {{ item && item.building_name }}
						<span class="wk-pick__hint">담은 매물은 리포트 맨 뒤에 붙고, 순서는 편집 화면에서 바꿉니다.</span>
					</p>
					<p v-if="weeklyNotice" class="wk-pick__notice" role="status">{{ weeklyNotice }}</p>
					<div class="table-wrap">
						<table class="table">
							<colgroup>
								<col style="width: 84px" />
								<col />
								<col style="width: 76px" />
								<col style="width: 64px" />
								<col style="width: 132px" />
							</colgroup>
							<tr>
								<th>주차</th>
								<th>제목</th>
								<th>매물</th>
								<th>상태</th>
								<th></th>
							</tr>
							<tr v-if="weeklyLoading">
								<td colspan="5" class="wk-pick__empty">불러오는 중…</td>
							</tr>
							<tr v-else-if="!weeklyTargets.length">
								<td colspan="5" class="wk-pick__empty">담을 수 있는 Weekly 가 없습니다. 아래에서 새로 만드세요.</td>
							</tr>
							<template v-else>
								<tr v-for="r in weeklyTargets" :key="'wk_' + r.report_uid">
									<td>{{ r.period_key }}</td>
									<td class="wk-pick__title">
										{{ r.title }}
										<span v-if="!r.mine" class="wk-pick__owner">{{ r.created_name || '-' }} 작성</span>
									</td>
									<td>{{ r.item_cnt }} / {{ weeklyMax }}건</td>
									<td :class="r.status === 'published' ? 'wk-pick__pub' : 'wk-pick__draft'">
										{{ r.status === 'published' ? '발행' : '작성중' }}
									</td>
									<td class="wk-pick__act">
										<template v-if="r.has_item">
											<span class="wk-pick__in">담김</span>
											<button type="button" class="btn btn-xsm btn-outline-secondary" :disabled="weeklyBusy" @click="removeFromWeekly(r)">빼기</button>
										</template>
										<button
											v-else
											type="button"
											class="btn btn-xsm btn-primary"
											:disabled="weeklyBusy || r.item_cnt >= weeklyMax"
											:title="r.item_cnt >= weeklyMax ? '매물은 최대 ' + weeklyMax + '건까지입니다' : ''"
											@click="addToWeekly(r)"
										>
											담기
										</button>
										<button type="button" class="btn btn-xsm btn-outline-secondary" @click="openWeeklyEdit(r)">편집</button>
									</td>
								</tr>
							</template>
						</table>
					</div>
					<table class="table type-input mt-3">
						<colgroup>
							<col style="width: 120px" />
							<col />
						</colgroup>
						<tr>
							<th>새 Weekly</th>
							<td>
								<div class="wk-pick__new">
									<input
										type="text"
										class="form-control"
										v-model="weeklyNewTitle"
										maxlength="120"
										placeholder="비워 두면 주차 제목이 붙습니다"
										@keyup.enter="createWeeklyWithItem"
									/>
									<button type="button" class="btn btn-sm btn-secondary" :disabled="weeklyBusy" @click="createWeeklyWithItem">
										새로 만들어 담기
									</button>
								</div>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		<div v-if="isPrintLogPopupShow" class="popup-wrap">
			<div class="dim" @click="isPrintLogPopupShow = false"></div>
			<div class="popup sm">
				<div class="popup-tit">
					출력로그
					<button type="button" class="btn btn-close" @click="isPrintLogPopupShow = false"><b-icon-x-lg /></button>
				</div>
				<div class="popup-con">
					<table class="table">
						<colgroup>
							<col width="30%" />
							<col width="20%" />
							<col width="50%" />
						</colgroup>
						<tr>
							<th>출력자</th>
							<th>직함</th>
							<th>출력일시</th>
						</tr>
						<tr v-if="!printLogList.length">
							<td colspan="3" style="text-align: center; color: #999">출력 이력이 없습니다.</td>
						</tr>
						<tr v-for="(log, i) in printLogList" :key="'plog_' + i">
							<td>{{ log.mem_name }}</td>
							<td>{{ log.mem_rank_name }}</td>
							<td>{{ $dateToFormat(log.printed_at, 'YYYY-MM-DD HH:mm:ss') }}</td>
						</tr>
					</table>
					<div class="print-log-pager" v-if="printLogTotalPages > 1">
						<button
							type="button"
							class="btn btn-sm btn-secondary"
							:disabled="printLogPage === 1"
							@click="setPrintLogPage(printLogPage - 1)"
						>
							이전
						</button>
						<span>{{ printLogPage }} / {{ printLogTotalPages }} (총 {{ printLogTotalCount }}건)</span>
						<button
							type="button"
							class="btn btn-sm btn-secondary"
							:disabled="printLogPage === printLogTotalPages"
							@click="setPrintLogPage(printLogPage + 1)"
						>
							다음
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Zoom, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/zoom';
import { normalizeAddr, formatLinkAddr } from '@/utils/format';

export default {
	name: 'MapDetail',
	components: {
		Swiper,
		SwiperSlide,
	},
	data() {
		return {
			bid: null,
			map: null,
			marker: null,
			marker2: null,
			pano: null,
			panoFailed: false, // 거리뷰(Panorama) 로드 실패 시 true → 안내 표시(지도는 영향 없음)
			imgSt: false,
			imgList: [],

			// ── 블록(bloc.ai.kr) 노출 (CN) ───────────────────────────────────────
			// blocForm 은 화면에서 만지는 값, blocLink 는 서버가 알고 있는 현재 상태다.
			// 둘을 나눠 두면 "무엇을 바꿨는지"(blocDirty)를 화면이 스스로 안다.
			blocLoaded: false,
			blocBusy: false,
			blocConfigured: false,
			blocConfigError: null,
			blocBase: '',
			blocExposable: false,
			blocExposableReason: null,
			blocLink: { expose: 'N', visibility: 'public', showFeatures: 'N', syncState: null, syncError: null, lastPushedAt: null, autoOffReason: null, blocPropertyId: null },
			blocForm: { expose: 'N', visibility: 'public', showFeatures: 'N' },
			blocPreview: { propertyType: null, imageCount: 0, featureLines: [] },

			modules: [Zoom, Pagination],
			item: null,
			kgeop: null, // K-GeoP 소유권/토지 조회 결과(읽기전용, 미저장)
			kgeopLoading: false,
			rentList: [],
			floorList: [],
			totalRentData: { m2: '0.00', py: '0.00', deposit: 0, money: 0, mgr: 0 },
			totalFloorData: { m2: '0.00', py: '0.00' },
			mgrLogList: [],
			clientLogList: [],
			workHistoryList: [],
			clientTypeList: [],
			landList: [],
			viewObj: {},
			searchOptions: {
				type: '',
				keyword: '',
				missed: false,
			},
			jinbun_addr: '',

			isPopupShow1: false,
			isPopupShow2: false,
			isPopupShow5: false,

			isPrintLogPopupShow: false,

			// Weekly 저장 팝업
			isWeeklyPopupShow: false,
			weeklyTargets: [],
			weeklyMax: 10,
			weeklyLoading: false,
			weeklyBusy: false,
			weeklyNotice: '',
			weeklyNewTitle: '',
			weeklySeq: 0,
			printLogList: [],
			printLogPage: 1,
			printLogSize: 10,
			printLogTotalCount: 0,
			printLogTotalPages: 0,

			popupData: {
				selectData: '',
				data: '',
				passwd: '',
			},
			memType: false,
			phoneView: false,

			typeTab1: false,
			typeTab2: false,
			typeTab3: false,

			calcInfo: {
				loan_money: 0,
				loan_rate: 3.5,
				year_loan_money: 0,
				buy_money: 0,
				month_loan_money: 0,
				loan_buy_money_per: 0,
				month_earn_money: 0,
				leverage_earn_rate: 0,

				sell_price: 0,
				land_price: 0,
				land_size_py_price: 0,
				building_price: 0,
				building_price_py_price: 0,
				total_size_py_price: 0,
				deposit: 0,
				rent_money: 0,
				mgr_fee: 0,
				total_income: 0,
				income_rate: 0,

				mgr_fee_out: 0,
			},
			calcStatus: [false, false, false, false, false, false],

			searchInfo: null,

			fileList: [],

			linkList: [],
			linkSumObj: {
				sum_sell_price: 0,
				sum_land_price: 0,
				sum_land_size_py_price: 0,
				sum_building_price: 0,
				sum_building_price_py_price: 0,
				sum_total_size_py_price: 0,
				sum_ex_sum_rent_deposit: 0,
				sum_ex_sum_rent_money: 0,
				sum_ex_sum_mgr_fee: 0,
				sum_ex_sum_mgr_fee_out: 0,
				sum_total_income: 0,
				sum_total_income_rate: 0,
				sum_land_size_m2: 0,
				sum_land_size_p: 0,
				sum_public_land_price: 0,
				sum_public_land_price_py_price: 0,
				sum_total_size_m2: 0,
				sum_total_size_p: 0,
				sum_build_size_m2: 0,
				sum_build_size_p: 0,

				itemList: [],
				item: {},
			},
		};
	},
	mounted() {},
	created() {
		// this.loadMap();
		this.bid = this.$route.params.id;

		// Bug AZ: 라우트 `/MapDetail/:id` 에 `/MapDetail/undefined` 등 잘못된 bid 가
		// 매칭되면 init() 의 8개 fan-out GET (item/rent/floor/mgrlog/clientlog/
		// workhistory/view/up-file) 이 모두 bid='undefined' 로 발사돼 backend
		// bid-guard 가 alert 8번을 뜨고 화면이 비어 있다. 진입점이 다양 (검색
		// 목록의 idList 가 undefined 인덱스를 돌려주는 케이스, 외부 북마크,
		// ScrapingDetail.goPick 의 re.item 이 비어있는 케이스 등) 해 호출 측 fix
		// 보다 컴포넌트 마운트 직후 일찍 차단하는 게 안전. Bug AY 의 MapWrite.init
		// guard 와 대칭 fix — 실제 5/13 13:05 발생한 24건 alert 스팜의 진원이
		// 이 경로 (URL 패턴 `&isDetail=true` 가 MapDetail.getItem 만 사용).
		const bidStr = String(this.bid);
		if (!this.bid || bidStr === 'undefined' || bidStr === 'null') {
			alert('잘못된 접근입니다. 매물 목록에서 다시 선택해주세요.');
			this.$router.replace('/');
			return;
		}

		// F-1: 스크립트 로드 promise 보관 → getItem() 에서 await 후 loadMap().
		// 지도는 base SDK('core')만으로 즉시 렌더하고, 거리뷰(Panorama)는 loadMap →
		// loadPanorama() 에서 panorama 서브모듈 준비를 따로 기다린다. 이렇게 분리하면
		// panorama 가 느리거나 실패해도 지도는 항상 뜨고, 거리뷰만 graceful 하게 누락된다.
		this.mapScriptReady = this.$loadNaverMaps('core');

		this.searchInfo = this.$route.query;

		this.init();
	},
	computed: {
		// 체크박스는 boolean 을 원하고 서버 계약은 'Y'/'N' 이다. 여기서 한 번만 번역한다 —
		// 화면 곳곳에서 문자열 비교를 하면 한 군데를 빠뜨리는 날 스위치가 조용히 안 먹는다.
		blocExposeOn: {
			get() { return this.blocForm.expose === 'Y'; },
			set(v) { this.blocForm.expose = v ? 'Y' : 'N'; },
		},
		blocFeatOn: {
			get() { return this.blocForm.showFeatures === 'Y'; },
			set(v) { this.blocForm.showFeatures = v ? 'Y' : 'N'; },
		},
		/** 서버가 아는 상태와 화면의 값이 다른가. 같으면 '적용' 을 누를 이유가 없다. */
		blocDirty() {
			if (!this.blocLoaded) return false;
			if (this.blocForm.expose !== this.blocLink.expose) return true;
			if (this.blocForm.expose !== 'Y') return false;   // 꺼진 상태에서는 등급·특징이 의미 없다
			return this.blocForm.visibility !== this.blocLink.visibility
				|| this.blocForm.showFeatures !== this.blocLink.showFeatures;
		},
		blocStateLabel() {
			if (!this.blocLoaded) return '';
			if (this.blocLink.expose !== 'Y') return '미노출';
			if (this.blocLink.syncState === 'error') return '전송 실패';
			if (this.blocLink.syncState === 'ok') return this.blocLink.visibility === 'hidden' ? '히든매물' : '공개';
			return '전송 대기';
		},
		blocAutoOffLabel() {
			const m = {
				sold: '이 매물이 매각으로 바뀌어 블록에서 자동으로 내렸습니다.',
				status: '이 매물의 진행상태가 바뀌어 블록에서 자동으로 내렸습니다.',
				deleted: '이 매물이 삭제되어 블록에서 자동으로 내렸습니다.',
				no_price: '매매가가 비어 블록에서 자동으로 내렸습니다.',
				no_coord: '좌표가 비어 블록에서 자동으로 내렸습니다.',
				no_addr: '지번주소가 비어 블록에서 자동으로 내렸습니다.',
			};
			return m[this.blocLink.autoOffReason] || '블록에서 자동으로 내려간 매물입니다.';
		},
		filteredMgrLogList() {
			return this.mgrLogList.filter(log => {
				if (log.sub_type_key === 'sell_status' && log.memo && log.memo.startsWith('작업중:')) return false;
				return true;
			});
		},
		combinedWorkList() {
			const rows = [];
			for (const wh of this.workHistoryList) {
				rows.push({
					kind: 'work',
					key: 'wh_' + wh.ts,
					date: wh.ts,
					label: '작업시작',
					doer: wh.assignee_name || '',
					desc: `작업기한: ${wh.sdate} ~ ${wh.edate}`,
				});
			}
			// 담당자 변경(building_mem_uid)은 변경내역 탭(filteredMgrLogList)에서만 렌더.
			// 여기선 sell_status 의 '작업중:' 구버전 작업시작 엔트리만 병합.
			for (const log of this.mgrLogList) {
				if (log.sub_type_key === 'sell_status' && log.memo && log.memo.startsWith('작업중:')) {
					rows.push({
						kind: 'work',
						key: 'ml_' + log.mgr_log_uid,
						date: log.date,
						label: '작업시작',
						doer: log.mem_name || '',
						desc: log.memo,
					});
				}
			}
			for (const log of this.clientLogList) {
				rows.push({
					kind: 'client',
					key: 'cl_' + log.client_log_uid,
					date: log.date,
					log,
				});
			}
			// `wh.ts` 는 'YYYY-MM-DD HH:mm:ss' (SP_BUILDING_WORK_START DATE_FORMAT),
			// `log.date` 는 ISO 'YYYY-MM-DDTHH:mm:ss.000Z'. 문자열 비교 시 space(0x20)
			// < 'T'(0x54) 라 작업시작·담당자 변경이 고객상담보다 위로 몰리므로 epoch 기준으로 정렬.
			const toEpoch = d => (d ? new Date(String(d).replace(' ', 'T')).getTime() : 0);
			rows.sort((a, b) => toEpoch(b.date) - toEpoch(a.date));
			return rows;
		},
		// G-2: 작업중 (신규~14일) — working_edate 가 오늘(로컬 KST 기준) 이상이면 작업중.
		// new Date('YYYY-MM-DD') 는 UTC 자정으로 파싱되어 KST 기준 09:00 이후 기한 당일이
		// false 로 바뀌는 버그가 있어, 로컬 YYYY-MM-DD 문자열 비교로 day-inclusive 판정한다.
		isWorkingActive() {
			// F-6.2 fix: working_edate may arrive as ISO UTC (mysql Date→JSON,
			// '2026-04-14T15:00:00.000Z' for KST midnight 2026-04-15) or as a
			// 'YYYY-MM-DD' string. Slicing the ISO form yields the UTC calendar
			// day, which is one day behind KST — the flag flipped false on the
			// deadline day itself. Extract local components via Date object so
			// both wire formats land on the same local YYYY-MM-DD.
			if (!this.item) return false;
			const ed = this.item.working_edate;
			if (!ed || ed === '0000-00-00') return false;
			const edDate = new Date(ed);
			if (isNaN(edDate.getTime())) return false;
			const edStr = `${edDate.getFullYear()}-${String(edDate.getMonth() + 1).padStart(2, '0')}-${String(edDate.getDate()).padStart(2, '0')}`;
			const now = new Date();
			const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
			return todayStr <= edStr;
		},
		// G-2: 매물/매각 상태에서는 작업 UI 전체 숨김.
		hideWorkUi() {
			if (!this.item) return true;
			return this.item.sell_status === 'done' || this.item.sell_status === 'sell';
		},
	},
	watch: {
		$route(to, form) {
			if (to.path !== form.path) {
				// console.log('변화감지');
				this.$reloadPage();
			}
		},
	},
	methods: {
		// G-2: "작업하기" — 14일 작업 우선권 부여. 물건카드(MapDetail) 에서도
		// 작업가능 상태일 때 버튼 노출 (readonly 뷰이지만 이 버튼은 액션).
		async btnStartWork() {
			if (this.hideWorkUi) return;
			if (this.isWorkingActive) return;

			const deadline = new Date();
			deadline.setDate(deadline.getDate() + 13);
			const y = deadline.getFullYear();
			const m = String(deadline.getMonth() + 1).padStart(2, '0');
			const d = String(deadline.getDate()).padStart(2, '0');
			const msg = `${y}년 ${m}월 ${d}일까지 작업 우선권이 부여됩니다.\n작업하시겠습니까?`;
			if (!confirm(msg)) return;

			const result = await this.$apiPOST('/admin/api/building/work/start', {
				bid: this.bid,
				isRent: false,
			});
			if (result && result.success) {
				alert('작업이 시작되었습니다.');
				// 작업내역 탭, 도형, 상단 표시를 일괄 갱신하기 위해 전체 리로드.
				// $router.go(n) 은 숫자만 받으므로 Route 객체 전달은 no-op.
				location.reload();
			} else {
				alert((result && result.message) || '작업 시작 실패');
			}
		},
		init() {
			this.calcStatus = [false, false, false, false, false];
			this.imgSt = false;
			this.imgList = [];
			this.getItem();
			this.getRent();
			this.getFloor();
			// 직원 전용 CRM 읽기(소유주/상담 로그·고객유형·작업이력)는 게스트가 호출하지 않는다.
			// 백엔드 adminApiAuthz 도 비직원에 403 — seon.js 가 403 에 alert 띄우므로, 게스트 상세
			// 진입 시 alert 폭탄을 막기 위해 프런트에서도 호출 자체를 건다(서버측 차단이 보안 경계).
			if (!this.$store.getters.getGuest) {
				this.getMgrLog();
				this.getClientLog();
				this.getWorkHistory();
				this.getClientType();
			}
			this.getView();
			this.getFileList();
		},
		getFileList() {
			this.$apiGET('/admin/api/up/file?bid=' + this.bid).then(re => {
				this.fileList = re;
			});
		},
		getTotal(act_type) {
			switch (act_type) {
				case 'first': //  맨처음      : idx = 1로 변경한다.
					if (this.searchInfo.idx == 1) {
						alert('처음입니다.');
						return;
					}
					this.searchInfo.idx = 1;
					break;
				case 'prev': //  이전        : 현재 idx = idx - 1 로 변경한다.
					if (this.searchInfo.idx == 1) {
						alert('처음입니다.');
						return;
					}
					this.searchInfo.idx--;
					break;
				case 'next': //  다음        : 현재 idx = idx + 1 로 변경한다.
					if (this.searchInfo.idx == this.searchInfo.totalCount) {
						alert('마지막입니다.');
						return;
					}
					this.searchInfo.idx++;
					break;
				case 'last': //  마지막      : 현재 idx = 마지막으로 변경한다.
					if (this.searchInfo.idx == this.searchInfo.totalCount) {
						alert('마지막입니다.');
						return;
					}
					this.searchInfo.idx = this.searchInfo.totalCount;
					break;
			}

			// this.item = null;

			if (this.searchInfo.mode == 'total') {
				let idList = this.$store.getters.getPageList[this.$route.query.pageIdx];

				this.bid = idList[this.searchInfo.idx - 1];
				this.$router.push({ path: '/MapDetail/' + this.bid, query: this.searchInfo });
			} else if (this.searchInfo.mode == 'count') {
				let idList = this.searchInfo.idList.split(',');
				this.bid = idList[this.searchInfo.idx - 1];
				// this.init();
				this.$router.push({ path: '/MapDetail/' + this.bid, query: this.searchInfo });
			} else if (this.searchInfo.mode == 'user_total') {
				this.$apiGET(
					'/admin/api/user/admin/detail/building/count?' +
						'page=' +
						(this.searchInfo.idx - 1) +
						'&keyword=' +
						this.searchInfo.keyword +
						'&st=' +
						this.searchInfo.st_,
				).then(data => {
					this.bid = data.building_uid;
					// this.init();
					this.$router.push({ path: '/MapDetail/' + this.bid, query: this.searchInfo });
				});
			} else if (this.searchInfo.mode == 'user_count') {
				this.$apiGET('/admin/api/user/admin/detail/count/count?' + 'page=' + (this.searchInfo.idx - 1)).then(data => {
					this.bid = data.building_uid;
					// this.init();
					this.$router.push({ path: '/MapDetail/' + this.bid, query: this.searchInfo });
				});
			}
		},
		calcLoan() {
			var sell_price = 0;
			var rent_deposit = 0;
			var total_income = 0;

			if (this.checkCalc()) {
				sell_price = this.calcInfo.sell_price; //  매매금액
				rent_deposit = this.calcInfo.deposit; //  보증금합계
				total_income = this.calcInfo.total_income; //  총수익
			} else {
				sell_price = this.item.sell_price; //  매매금액
				rent_deposit = this.item.ex_sum_rent_deposit; //  보증금합계
				total_income = this.item.total_income; //  총수익
			}

			//  연이자액 = 대출금액*대출금리
			this.calcInfo.year_loan_money = Math.round(this.calcInfo.loan_money * (this.calcInfo.loan_rate / 100));

			//  구입자금 = 매매금액 - 보증금 - 대출금액
			this.calcInfo.buy_money = sell_price * 1 - rent_deposit * 1 - this.calcInfo.loan_money * 1;

			//  월이자액 = (대출금액*대출금리)/12
			this.calcInfo.month_loan_money = Math.round(this.calcInfo.year_loan_money / 12);

			//  대부비율 = (대출금액/매매금액)*100
			this.calcInfo.loan_buy_money_per = Math.round((this.calcInfo.loan_money / sell_price) * 100 * 100) / 100;

			//  월순수입 = 총수익 - 월이자액
			this.calcInfo.month_earn_money = total_income - this.calcInfo.month_loan_money;

			// 레버리지수익률 월순수입 * 12 / 구입자금 * 100
			this.calcInfo.leverage_earn_rate =
				Math.round(((this.calcInfo.month_earn_money * 12) / this.calcInfo.buy_money) * 100 * 100) / 100;
		},
		// 제휴 게스트(은행직원) 물건 담기 → 장바구니 추가
		/**
		 * 브리핑대기물건저장: 매매검색의 '고객탭연결' 과 같은 고객 선택 창(UserAdmin2)을 이 매물 한 건으로 연다.
		 * 그 창은 처음에 내 담당 고객만 보여 주고, 고른 고객들의 브리핑 대기 목록에 이 매물이 들어간다.
		 */
		btnOnBriefing() {
			const w = window.screen.availWidth;
			const h = window.screen.availHeight;
			window.open('/UserAdmin2?brifList=' + this.bid, '', 'width=' + w + ', height=' + h + ', resizable=no, status=no');
		},
		openWeeklyPopup() {
			this.weeklyNotice = '';
			this.weeklyNewTitle = '';
			this.isWeeklyPopupShow = true;
			this.loadWeeklyTargets();
		},
		loadWeeklyTargets() {
			// 옛 목록을 남겨 두면 그 사이 발행된 리포트가 '작성중' 으로 보여 발행 확인 없이 담긴다.
			// 새로 받기 전에 비우고, 늦게 온 옛 응답은 버린다.
			const seq = ++this.weeklySeq;
			this.weeklyTargets = [];
			this.weeklyLoading = true;
			return this.$apiGET('/admin/api/report/targets?buildingType=sell&bid=' + this.bid).then(re => {
				if (seq !== this.weeklySeq) return;
				this.weeklyLoading = false;
				if (!re || !Array.isArray(re.list)) {
					this.weeklyNotice = 'Weekly 목록을 불러오지 못했습니다. 창을 닫았다가 다시 열어 주세요.';
					return;
				}
				this.weeklyTargets = re.list;
				if (re.maxItems) this.weeklyMax = re.maxItems;
			});
		},
		addToWeekly(r) {
			// 발행한 리포트는 이미 나간 고객 링크에 곧바로 보인다. 모르고 담지 않게 한 번 묻는다.
			if (r.status === 'published' && !confirm('이미 발행된 리포트입니다. 담으면 보낸 고객 링크에도 바로 보입니다. 담을까요?')) return;
			this.weeklyBusy = true;
			this.$apiPOST('/admin/api/report/item/add', { reportUid: r.report_uid, bid: this.bid, buildingType: 'sell' }).then(re => {
				this.weeklyBusy = false;
				if (!re || !re.ok) return;
				this.weeklyNotice = re.already ? `이미 '${r.title}' 에 담겨 있습니다.` : `'${r.title}' 에 담았습니다. 지금 ${re.itemCnt}건입니다.`;
				this.loadWeeklyTargets();
			});
		},
		removeFromWeekly(r) {
			const warn = r.status === 'published' ? ' 발행된 리포트라 보낸 고객 링크에서도 바로 사라집니다.' : '';
			if (!confirm(`'${r.title}' 에서 이 매물을 뺍니다. 이 매물에 적어 둔 코멘트와 태그도 함께 지워집니다.${warn} 뺄까요?`)) return;
			this.weeklyBusy = true;
			this.$apiPOST('/admin/api/report/item/remove', { reportUid: r.report_uid, bid: this.bid, buildingType: 'sell' }).then(re => {
				this.weeklyBusy = false;
				if (!re || !re.ok) return;
				this.weeklyNotice = re.removed ? `'${r.title}' 에서 뺐습니다. 지금 ${re.itemCnt}건입니다.` : `'${r.title}' 에 담겨 있지 않습니다.`;
				this.loadWeeklyTargets();
			});
		},
		createWeeklyWithItem() {
			if (this.weeklyBusy) return;
			this.weeklyBusy = true;
			this.$apiPOST('/admin/api/report/create', { title: this.weeklyNewTitle, buildingType: 'sell', bidList: [Number(this.bid)] }).then(re => {
				this.weeklyBusy = false;
				if (!re || !re.ok) return;
				this.weeklyNewTitle = '';
				this.weeklyNotice = '새 Weekly 를 만들고 이 매물을 담았습니다. 다른 매물을 넘겨 보며 계속 담을 수 있습니다.';
				this.loadWeeklyTargets();
			});
		},
		/** 편집 화면은 새 창으로 연다 — 넘겨 보던 매물 상세를 잃지 않게. */
		openWeeklyEdit(r) {
			const w = window.screen.availWidth;
			const h = window.screen.availHeight;
			window.open('/ReportEdit/' + r.report_uid, '', 'width=' + w + ', height=' + h + ', resizable=yes, status=no');
		},
		async btnAddCart() {
			const re = await this.$apiPOST('/partner/api/cart/add', { buildingType: 'sell', bid: this.bid });
			if (re && re.st) alert('물건을 담았습니다.');
		},

		// ── 블록(bloc.ai.kr) 노출 (CN) ───────────────────────────────────────────
		/**
		 * 현재 노출 상태 + 켰을 때 나갈 값의 미리보기를 받아온다.
		 * 실패해도 매물 화면 전체를 깨뜨리지 않는다 — 패널만 '불러오는 중' 으로 남는다.
		 */
		loadBloc() {
			if (this.$store.getters.getGuest) return;   // 게스트는 패널 자체가 없다
			if (!this.bid) return;   // 매물 번호 없이 부르면 서버 가드가 400 으로 막고 알림창을 띄운다
			return this.$apiGET('/admin/api/bloc/item?type=sell&bid=' + this.bid)
				.then(res => {
					if (!res || !res.ok) return;
					this.blocConfigured = !!res.configured;
					this.blocConfigError = res.configError || null;
					this.blocBase = res.blocBase || '';
					this.blocExposable = !!res.exposable;
					this.blocExposableReason = res.exposableReason || null;
					this.blocLink = res.link;
					this.blocPreview = res.preview || { propertyType: null, imageCount: 0, featureLines: [] };
					// 화면 값은 서버 상태에서 새로 시작한다(다른 탭에서 바꾼 결과를 덮어쓰지 않도록).
					this.blocForm = {
						expose: res.link.expose,
						visibility: res.link.visibility || 'public',
						showFeatures: res.link.showFeatures || 'N',
					};
					this.blocLoaded = true;
				})
				.catch(() => {});
		},

		/** 설정을 저장하고 그 자리에서 블록으로 보낸다. 결과 문장을 그대로 담당자에게 보여 준다. */
		saveBloc() {
			if (this.blocBusy) return;
			if (this.blocForm.expose === 'Y' && this.blocForm.visibility === 'public') {
				if (!confirm('이 매물을 블록에 공개로 올립니다.\n블록은 로그인 없이 누구나 볼 수 있는 사이트입니다. 계속할까요?')) return;
			}
			this.blocBusy = true;
			this.$apiPOST('/admin/api/bloc/item/expose', {
				type: 'sell',
				bid: this.bid,
				expose: this.blocForm.expose,
				visibility: this.blocForm.visibility,
				showFeatures: this.blocForm.showFeatures,
			})
				.then(res => {
					if (res && res.link) this.applyBlocResult(res);
					if (res && res.message) alert(res.message);
				})
				.finally(() => {
					this.blocBusy = false;
					this.loadBloc();
				});
		},

		/** 실패한 전송을 다시 시도한다(내용이 같아도 강제로 보낸다). */
		resyncBloc() {
			if (this.blocBusy) return;
			this.blocBusy = true;
			this.$apiPOST('/admin/api/bloc/item/resync', { type: 'sell', bid: this.bid })
				.then(res => {
					if (res && res.link) this.applyBlocResult(res);
					if (res && res.message) alert(res.message);
				})
				.finally(() => {
					this.blocBusy = false;
					this.loadBloc();
				});
		},

		applyBlocResult(res) {
			this.blocLink = res.link;
			this.blocForm = {
				expose: res.link.expose,
				visibility: res.link.visibility || 'public',
				showFeatures: res.link.showFeatures || 'N',
			};
		},

		/** 블록에서 이 매물이 어떻게 보이는지 새 창으로 연다. */
		openBlocProperty() {
			if (!this.blocLink.blocPropertyId) return;
			const base = this.blocBase || 'https://bloc.ai.kr';
			window.open(base + '/properties/' + this.blocLink.blocPropertyId, 'pop_bloc_item');
		},

		getItem() {
			this.$apiGET('/admin/api/detail/item?bid=' + this.bid + '&isRent=false&isDetail=true').then(data => {
				// Bug AF: 백엔드가 row 미존재 시 res.send(false) → data === false. 후속
				// data.total_income 등 접근에서 TypeError. 알리고 목록으로 복귀.
				if (!data || typeof data !== 'object') {
					// CQ: 열람 속도 제한(403) 처럼 API 계층이 이미 사유를 띄웠으면 '매물 없음' 을 겹쳐 띄우지 않는다.
					if (!this.$didApiAlert()) alert('해당 매물 정보를 찾을 수 없습니다.\n매물 목록으로 돌아갑니다.');
					this.$router.go(-1);
					return;
				}
				for (let prop in data) {
					if (data[prop] == null) {
						data[prop] = '';
					}
				}

				if (!data.total_income) {
					data.total_income = 0;
				}

				if (!data.total_income_rate) {
					data.total_income_rate = 0;
				}

				this.item = data;

				// 제휴 게스트(은행직원) 조회 비콘 (best-effort, ID-only)
				if (this.$store.getters.getGuest && this.$store.getters.getInstitution) {
					this.$apiPOST('/partner/api/log/view', { buildingType: 'sell', bid: this.bid });
				}

				this.imgSt = false;
				for (let i = 0; i < this.item.imgList.length; i++) {
					if (this.item.imgList[i]) {
						this.imgSt = true;
						this.imgList.push(process.env.VUE_APP_HOST_BACK + '/users/item/image?id=' + this.item.imgList[i] + '&w=1200&q=82');
					}
				}

				if (
					this.item.building_mem_uid == this.$store.getters.getUserInfo.mem_uid ||
					'master' == this.$store.getters.getUserInfo.mem_type
				) {
					this.memType = true;
				}

				this.linkSumObj.item = {
					building_name: data.building_name,
					jibun_addr: data.jibun_addr,
					sell_price: data.sell_price,
					land_price: data.land_price,
					land_size_py_price: data.land_size_py_price,
					building_price: data.building_price,
					building_price_py_price: data.building_price_py_price,
					total_size_py_price: data.total_size_py_price,
					ex_sum_rent_deposit: data.ex_sum_rent_deposit,
					ex_sum_rent_money: data.ex_sum_rent_money,
					ex_sum_mgr_fee: data.ex_sum_mgr_fee,
					ex_sum_mgr_fee_out: data.ex_sum_mgr_fee_out,
					total_income: data.total_income,
					total_income_rate: data.total_income_rate,
					land_size_m2: data.land_size_m2,
					land_size_p: data.land_size_p,
					public_land_price: data.public_land_price,
					public_land_price_py_price: data.public_land_price_py_price,
					total_size_m2: data.total_size_m2,
					total_size_p: data.total_size_p,
					build_size_m2: data.build_size_m2,
					build_size_p: data.build_size_p,
				};

				this.getList();
				this.getLand();
				this.loadBloc();

				this.mapScriptReady
					.then(() => { this.loadMap(); })
					.catch(e => { console.warn('Naver Maps script failed:', e); });
			});
		},
		getRent() {
			this.$apiGET('/admin/api/detail/item/rent?bid=' + this.bid).then(data => {
				this.rentList = data;
				let m2 = 0, py = 0, deposit = 0, money = 0, mgr = 0;
				for (let i = 0; i < data.length; i++) {
					m2 += Number(data[i].rent_size_m2);
					py += Number(data[i].rent_size_p);
					if (data[i].except_flag != 'Y') {
						deposit += Number(data[i].rent_deposit);
						money += Number(data[i].rent_money);
						mgr += Number(data[i].mgr_fee);
					}
				}
				this.totalRentData = { m2: m2.toFixed(2), py: py.toFixed(2), deposit, money, mgr };
			});
		},
		getFloor() {
			this.$apiGET('/admin/api/detail/item/floor?bid=' + this.bid).then(data => {
				this.floorList = data;
				let m2 = 0, py = 0;
				for (let i = 0; i < data.length; i++) {
					// 건축물대장이 면적 제외로 표시한 행(옥탑 계단실 등)은 연면적에 들지 않는다(DD). 담당자 제외 체크와는 별개다.
					if (String(data[i].areaExctYn) === '1') continue;
					m2 += Number(data[i].area_m2);
					py += Number(data[i].area_py);
				}
				this.totalFloorData = { m2: m2.toFixed(2), py: py.toFixed(2) };
			});
		},
		// K-GeoP(한국국토정보공사) 소유권/토지 조회. item.pnu_code 기반 읽기전용 조회(DB 미저장).
		// 개인 소유자명/등록번호는 원본 서버에서 마스킹되어 내려온다(법인만 실명).
		getKGeop() {
			if (!this.item || !this.item.pnu_code) {
				alert('PNU(필지고유번호)가 없어 조회할 수 없습니다.');
				return;
			}
			this.kgeopLoading = true;
			this.$apiGET('/admin/api/detail/item/kgeop?pnu=' + this.item.pnu_code, { timeout: 25000 })
				.then(data => {
					this.kgeopLoading = false;
					if (!data) return; // $apiGET 에서 이미 alert 처리됨
					if (data.ok === false) {
						alert(data.msg || 'K-GeoP 조회에 실패했습니다.');
						return;
					}
					this.kgeop = data;
				})
				.catch(() => {
					this.kgeopLoading = false;
					alert('K-GeoP 조회 중 오류가 발생했습니다.');
				});
		},
		getLand() {
			this.$apiGET('/admin/api/detail/item/edit/land?bid=' + this.bid).then(data => {
				// F-2.3: 중복 주소 제거 후 결합
				// F-2.1: legacy row 방어 — 백엔드 shortAdr 이 뒤늦게 붙기 전에
				// 저장된 row 는 "서울특별시 … 번지" 원시 문자열이 그대로 남아
				// 있을 수 있으므로 렌더 직전에 normalizeAddr 을 한 번 더 적용한다.
				// formatLinkAddr: 첫 주소는 풀주소 유지, 2번째부터는 "시 구" 제거해 "동 번지" 만.
				const uniqueAddrs = [...new Set(
					data.map(d => normalizeAddr(d.jibun_addr)).filter(Boolean)
				)];
				const fallback = normalizeAddr(this.item.jibun_addr);
				const jinbun_addr = formatLinkAddr(uniqueAddrs) || fallback;
				this.jinbun_addr = jinbun_addr;
			});
		},
		getClientLog() {
			this.$apiGET('/admin/api/detail/item/clientlog?bid=' + this.bid).then(data => {
				this.clientLogList = data;
			});
		},
		getWorkHistory() {
			this.$apiGET('/admin/api/detail/item/workhistory?bid=' + this.bid + '&isRent=false').then(data => {
				this.workHistoryList = data;
			});
		},
		// CZ: 전화로 분류된 구분이면 '부재' 선택을 보인다. 고르지 않으면 통화완료로 저장된다(KPI 1통).
		isCallType() {
			const t = this.clientTypeList.find(c => c.ind_cfg_uid == this.searchOptions.type);
			return !!(t && t.is_call);
		},
		addClientLog() {
			// J-2/Bug V: backend tx 5xx 시 keyword reset / getClientLog 차단.
			this.$apiPOST('/admin/api/client/log/add', {
				bid: this.bid,
				type: this.searchOptions.type,
				keyword: this.searchOptions.keyword,
				memUid: this.item.building_mem_uid,
				callResult: this.isCallType() && this.searchOptions.missed ? 'missed' : 'done',
			}).then(re => {
				if (re !== true) return;
				this.searchOptions.keyword = '';
				this.searchOptions.missed = false;
				this.getClientLog();
			});
		},
		getMgrLog() {
			this.$apiGET('/admin/api/detail/item/mgrlog?bid=' + this.bid).then(data => {
				this.mgrLogList = data;
			});
		},
		async getClientType() {
			const list = await this.$store.dispatch('ensureClientTypeList', () =>
				this.$apiGET('/admin/api/detail/item/clienttype'),
			);
			this.clientTypeList = list;

			if (this.clientTypeList.length) {
				this.searchOptions.type = this.clientTypeList[0].ind_cfg_uid;
			}
		},
		getView() {
			this.$apiGET('/admin/api/detail/item/view?bid=' + this.bid).then(data => {
				this.viewObj = data;
			});
		},
		loadMap() {
			// F-4.1: Guard — do not recreate the map if it is already initialized.
			// Re-initializing resets the center to the hardcoded fallback (37.5112,
			// 127.0981) before setCenter() can correct it, causing visible jumps when
			// an async data callback fires while the user is interacting with the map.
			if (this.map) return;
			if (!this.item || !this.item.pt) return;

			this.map = new window.naver.maps.Map('map', {
				center: new window.naver.maps.LatLng(this.item.pt.y, this.item.pt.x),
				zoom: 18,
			});

			if (this.$store.getters.getGuest) {
				this.map.setSize({ width: '804px', height: '500px' });
			} else {
				this.map.setSize({ width: '504px', height: '500px' });
			}

			this.marker = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(this.item.pt.y, this.item.pt.x),
				map: this.map,
			});

			if (!this.imgSt) {
				this.loadPanorama();
			}
		},
		// 거리뷰(Panorama)는 panorama 서브모듈 준비를 따로 기다려 생성한다. 지도는 이미
		// loadMap 에서 렌더됐으므로, panorama 가 느리거나 실패해도 지도는 영향받지 않는다.
		loadPanorama() {
			this.$loadNaverMaps('panorama')
				.then(() => {
					this.pano = new window.naver.maps.Panorama('pano', {
						position: new window.naver.maps.LatLng(this.item.pt.y, this.item.pt.x),
					});

					this.marker2 = new window.naver.maps.Marker({
						position: new window.naver.maps.LatLng(this.item.pt.y, this.item.pt.x),
						map: this.pano,
					});

					window.naver.maps.Event.addListener(this.pano, 'init', function () {
						this.marker2.setMap(this.pano);

						var proj = this.pano.getProjection();
						var lookAtPov = proj.fromCoordToPov(this.marker2.getPosition());
						if (lookAtPov) {
							this.pano.setPov(lookAtPov);
						}
					});
				})
				.catch(() => {
					// 거리뷰 로드 실패/타임아웃 → 빈 화면 대신 안내. 지도는 이미 렌더됨.
					this.panoFailed = true;
				});
		},
		goEdit() {
			// Bug AY: 라우트는 `/MapWrite/:id` (path param) — `query: { id: 1 }` 로 넘기면
			// `params.id` 가 undefined 가 되어 MapWrite.init 의 `this.bid = $route.params.id`
			// 가 undefined 가 되고, 마운트 직후 발사되는 8개 GET (item/rent/floor/mgrlog/
			// clientlog/workhistory/view/up-file) 이 bid='undefined' 로 호출돼 backend
			// bid-guard 가 일괄 400 + alert → 사용자가 동일한 alert 8번 보고 무엇을
			// 해야 할 지 모름. 현재 viewing 중인 bid 를 params 로 넘긴다.
			this.$router.push({ name: 'MapWrite', params: { id: this.bid } });
		},
		btnOnPrint() {
			let w = window.screen.availWidth;
			let h = window.screen.availHeight;

			let attr = 'width=' + w + ', height=' + h + ', resizable=no, status=no';

			let st = false;

			for (let i = 0; i < this.calcStatus.length; i++) {
				if (this.calcStatus[i]) {
					st = true;
					break;
				}
			}

			if (st) {
				window.open(
					'/PrintPage?bid=' +
						this.bid +
						'&st=' +
						true +
						'&sell_price=' +
						this.calcInfo.sell_price +
						'&land_price=' +
						this.calcInfo.land_price +
						'&land_size_py_price=' +
						this.calcInfo.land_size_py_price +
						'&building_price=' +
						this.calcInfo.building_price +
						'&building_price_py_price=' +
						this.calcInfo.building_price_py_price +
						'&total_size_py_price=' +
						this.calcInfo.total_size_py_price +
						'&ex_sum_rent_deposit=' +
						this.calcInfo.deposit +
						'&ex_sum_rent_money=' +
						this.calcInfo.rent_money +
						'&ex_sum_mgr_fee=' +
						this.calcInfo.mgr_fee +
						'&ex_sum_mgr_fee_out=' +
						this.calcInfo.mgr_fee_out +
						'&total_income=' +
						this.calcInfo.total_income +
						'&total_income_rate=' +
						this.calcInfo.income_rate,
					'',
					attr,
				);
			} else {
				window.open('/PrintPage?bid=' + this.bid, '', attr);
			}
		},
		btnMgrLogDel(id) {
			this.$apiPOST('/admin/api/mgr/log/del', {
				id: id,
			}).then(() => {
				this.getMgrLog();
			});
		},
		btnClientLogDel(id) {
			this.$apiPOST('/admin/api/client/log/del', {
				id: id,
			}).then(() => {
				this.getClientLog();
			});
		},
		openPrintLogModal() {
			this.printLogPage = 1;
			this.isPrintLogPopupShow = true;
			this.loadPrintLog();
		},
		async loadPrintLog() {
			const q = `bid=${this.bid}&type=sell&page=${this.printLogPage}&size=${this.printLogSize}`;
			const res = await this.$apiGET('/admin/api/detail/item/print/log?' + q);
			if (res && res.st) {
				this.printLogList = res.list || [];
				this.printLogTotalCount = res.totalCount || 0;
				this.printLogTotalPages = res.totalPages || 0;
			}
		},
		setPrintLogPage(p) {
			if (p < 1 || p > this.printLogTotalPages) return;
			this.printLogPage = p;
			this.loadPrintLog();
		},
		sendPhone() {
			if (!this.popupData.selectData) {
				alert('조회사유를 선택하세요.');
				return;
			}

			if (this.popupData.selectData == '직접입력' && !this.popupData.data) {
				alert('조회사유를 입력하세요.');
				return;
			}

			if (!this.popupData.passwd) {
				alert('비밀번호를 입력하세요.');
				return;
			}

			if (this.item.building_uid != this.popupData.passwd) {
				alert('비밀번호가 일치하지 않습니다.');
				return;
			}

			let memo = this.popupData.selectData == '직접입력' ? this.popupData.data : this.popupData.selectData;
			this.$apiPOST('/admin/api/oper/owner/log/add', { bid: this.bid, memo: memo }).then(re => {
				// J-2/Bug R-2: 소유자 연락처 조회 audit log 가 실패했는데 phoneView 를 켜면
				// "log 없이 phone 노출" — privacy/compliance 측면에서 audit trail 결손.
				// log 가 명시적 success 일 때만 phone 공개.
				// CQ(2026-09-18): 상세 응답의 연락처는 담당자·master 가 아니면 서버에서 마스킹되어 온다.
				// 조회사유 기록에 성공하면 서버가 응답에 원문을 실어 준다 → 그 값으로 바꿔 넣고 연다.
				const ok = re === true || (re && re.ok === true);
				if (!ok) return;
				if (re && re.owner) Object.assign(this.item, re.owner);
				this.phoneView = true;
				this.isPopupShow1 = false;
			});
		},
		btnOnDetail() {
			let w = window.screen.availWidth;
			let h = window.screen.availHeight;

			let attr = 'width=' + w + ', height=' + h + ', resizable=no, status=no';

			window.open('/MapSearch2?isId=' + this.bid + '&st=' + this.item.sell_status, '', attr);
		},
		btnCalc(idx) {
			if (!this.checkCalc()) {
				this.calcInfo.sell_price = this.item.sell_price;
				this.calcInfo.land_price = this.item.land_price;
				this.calcInfo.land_size_py_price = this.item.land_size_py_price;
				this.calcInfo.building_price = this.item.building_price;
				this.calcInfo.building_price_py_price = this.item.building_price_py_price;
				this.calcInfo.total_size_py_price = this.item.total_size_py_price;
				this.calcInfo.deposit = this.item.ex_sum_rent_deposit;
				this.calcInfo.rent_money = this.item.ex_sum_rent_money;
				this.calcInfo.mgr_fee = this.item.ex_sum_mgr_fee;
				this.calcInfo.total_income = this.item.total_income;
				this.calcInfo.income_rate = this.item.total_income_rate;
				this.calcInfo.mgr_fee_out = this.item.ex_sum_mgr_fee_out;
			}

			if (this.calcStatus[idx]) {
				this.calcStatus[idx] = false;
			} else {
				this.calcStatus[idx] = true;
			}
		},
		checkCalc() {
			for (let i = 0; i < this.calcStatus.length; i++) {
				if (this.calcStatus[i]) {
					return true;
				}
			}
			return false;
		},
		chageCalc() {
			//  토지가격 계산
			if (this.item.land_size_p > 0) {
				this.calcInfo.land_price = this.calcInfo.sell_price - this.calcInfo.building_price;
				this.calcInfo.land_size_py_price = (this.calcInfo.land_price / this.item.land_size_p).toFixed(0);
			}
			//  연면적 평당가
			if (this.item.total_size_p > 0) {
				this.calcInfo.building_price = this.item.total_size_p * this.calcInfo.building_price_py_price;
				this.calcInfo.total_size_py_price = (this.calcInfo.sell_price / this.item.total_size_p).toFixed(0);
			}

			this.calcInfo.total_income =
				this.calcInfo.rent_money * 1 + this.calcInfo.mgr_fee * 1 - this.calcInfo.mgr_fee_out * 1;

			//  수익률 = (총수익*12) / (매매금액-보증금합계) * 100
			if (this.calcInfo.sell_price - this.calcInfo.deposit != 0) {
				this.calcInfo.income_rate = (
					((this.calcInfo.total_income * 12) / (this.calcInfo.sell_price - this.calcInfo.deposit)) *
					100
				).toFixed(2);
			}
		},
		downFile(id, item) {
			this.$apiDOWN('/admin/api/up/file/item?id=' + id, item.type).then(re => {
				const url = window.URL.createObjectURL(new Blob([re]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', item.org_name); //or any other extension
				document.body.appendChild(link);
				link.click();
			});
		},
		getList() {
			this.$apiGET('/admin/api/detail/item/b/link?bid=' + this.bid).then(re => {
				this.linkList = JSON.parse(JSON.stringify(re));

				let itemList = [];

				itemList = itemList.concat(this.linkSumObj.item, JSON.parse(JSON.stringify(re)));

				this.linkSumObj.itemList = [];
				this.linkSumObj.itemList = itemList;

				this.linkSumObj.sum_sell_price = 0;
				this.linkSumObj.sum_land_price = 0;
				this.linkSumObj.sum_land_size_py_price = 0;
				this.linkSumObj.sum_building_price = 0;
				this.linkSumObj.sum_building_price_py_price = 0;
				this.linkSumObj.sum_total_size_py_price = 0;
				this.linkSumObj.sum_ex_sum_rent_deposit = 0;
				this.linkSumObj.sum_ex_sum_rent_money = 0;
				this.linkSumObj.sum_ex_sum_mgr_fee = 0;
				this.linkSumObj.sum_ex_sum_mgr_fee_out = 0;
				this.linkSumObj.sum_total_income = 0;
				this.linkSumObj.sum_total_income_rate = 0;
				this.linkSumObj.sum_land_size_m2 = 0;
				this.linkSumObj.sum_land_size_p = 0;
				this.linkSumObj.sum_public_land_price = 0;
				this.linkSumObj.sum_public_land_price_py_price = 0;
				this.linkSumObj.sum_total_size_m2 = 0;
				this.linkSumObj.sum_total_size_p = 0;
				this.linkSumObj.sum_build_size_m2 = 0;
				this.linkSumObj.sum_build_size_p = 0;

				for (let i = 0; i < this.linkSumObj.itemList.length; i++) {
					this.linkSumObj.sum_sell_price += Number(this.linkSumObj.itemList[i].sell_price);
					this.linkSumObj.sum_land_price += Number(this.linkSumObj.itemList[i].land_price);
					this.linkSumObj.sum_land_size_py_price += Number(this.linkSumObj.itemList[i].land_size_py_price);
					this.linkSumObj.sum_building_price += Number(this.linkSumObj.itemList[i].building_price);
					this.linkSumObj.sum_building_price_py_price += Number(this.linkSumObj.itemList[i].building_price_py_price);
					this.linkSumObj.sum_total_size_py_price += Number(this.linkSumObj.itemList[i].total_size_py_price);
					this.linkSumObj.sum_ex_sum_rent_deposit += Number(this.linkSumObj.itemList[i].ex_sum_rent_deposit);
					this.linkSumObj.sum_ex_sum_rent_money += Number(this.linkSumObj.itemList[i].ex_sum_rent_money);
					this.linkSumObj.sum_ex_sum_mgr_fee += Number(this.linkSumObj.itemList[i].ex_sum_mgr_fee);
					this.linkSumObj.sum_ex_sum_mgr_fee_out += Number(this.linkSumObj.itemList[i].ex_sum_mgr_fee_out);
					this.linkSumObj.sum_total_income += Number(this.linkSumObj.itemList[i].total_income);
					this.linkSumObj.sum_total_income_rate += Number(this.linkSumObj.itemList[i].total_income_rate);
					this.linkSumObj.sum_land_size_m2 += Number(this.linkSumObj.itemList[i].land_size_m2);
					this.linkSumObj.sum_land_size_p += Number(this.linkSumObj.itemList[i].land_size_p);
					this.linkSumObj.sum_public_land_price += Number(this.linkSumObj.itemList[i].public_land_price);
					this.linkSumObj.sum_public_land_price_py_price += Number(
						this.linkSumObj.itemList[i].public_land_price_py_price,
					);
					this.linkSumObj.sum_total_size_m2 += Number(this.linkSumObj.itemList[i].total_size_m2);
					this.linkSumObj.sum_total_size_p += Number(this.linkSumObj.itemList[i].total_size_p);
					this.linkSumObj.sum_build_size_m2 += Number(this.linkSumObj.itemList[i].build_size_m2);
					this.linkSumObj.sum_build_size_p += Number(this.linkSumObj.itemList[i].build_size_p);
				}
			});
		},
		btnOnDetail2(id) {
			let w = window.screen.availWidth;
			let h = window.screen.availHeight;

			let attr = 'width=' + w + ', height=' + h + ', resizable=no, status=no';

			window.open('/MapDetail/' + id, '', attr);
		},
	},
};
</script>

<style scoped>
.work-row td,
.work-row:hover td {
	background-color: #FFF9C4 !important;
}

/* ── 블록 노출 패널 (CN) ─────────────────────────────────────────────────────
   회사 밖으로 나가는 스위치라 눈에 띄어야 하지만, 콘솔의 다른 패널과 톤이 달라
   튀면 안 된다. 상태 배지 하나로 현재 상태를 먼저 읽게 한다. */
.bloc-state {
	font-size: 11px;
	font-weight: 600;
	padding: 2px 8px;
	border-radius: 10px;
	margin-left: 6px;
	vertical-align: middle;
	background: #eceff1;
	color: #546e7a;
}
.bloc-state.st-ok { background: #e3f2fd; color: #1565c0; }
.bloc-state.st-error { background: #ffebee; color: #c62828; }
.bloc-state.st-pending { background: #fff8e1; color: #ef6c00; }

.bloc-box {
	padding: 10px 12px;
	font-size: 13px;
	line-height: 1.6;
}
.bloc-warn {
	background: #fff8e1;
	border-left: 3px solid #ffb300;
	padding: 6px 10px;
	margin-bottom: 8px;
	color: #6d4c41;
}
.bloc-err {
	background: #ffebee;
	border-left: 3px solid #e53935;
	padding: 6px 10px;
	margin-bottom: 8px;
	color: #b71c1c;
	word-break: break-all;
}
.bloc-toggle {
	display: block;
	font-weight: 600;
	cursor: pointer;
}
.bloc-toggle input { margin-right: 6px; }

.bloc-grade {
	display: flex;
	gap: 8px;
	margin: 8px 0 4px;
}
.bloc-grade label {
	flex: 1;
	border: 1px solid #dfe3e8;
	border-radius: 4px;
	padding: 8px 10px;
	cursor: pointer;
}
.bloc-grade label.on { border-color: #1565c0; background: #f3f8ff; }
.bloc-grade label input { margin-right: 6px; }
.bloc-grade em {
	display: block;
	font-style: normal;
	font-size: 11px;
	color: #78909c;
	margin-left: 20px;
}

.bloc-feat { margin-top: 10px; }
.bloc-feat-list {
	margin: 4px 0 0 18px;
	padding: 0;
	font-size: 12px;
	color: #455a64;
}
.bloc-feat-list.off { color: #b0bec5; }

.bloc-meta {
	margin-top: 8px;
	font-size: 11px;
	color: #90a4ae;
}
.bloc-meta span + span::before { content: ' · '; }

.bloc-actions {
	margin-top: 10px;
	display: flex;
	gap: 6px;
}

/* 하단 버튼 줄에 'Weekly 저장' 이 붙어 오른쪽 버튼 묶음이 약 310px 로 넓어졌다. 쪽 이동 칸(공통 규칙은
   right:240px)이 그 밑에 깔려 '편집모드' 가 » 단추를 덮었다(실측). 이 화면에서만 칸을 왼쪽으로 옮긴다.
   상세 화면 최소폭(1450px)에서도 왼쪽 담당자 칸과 170px 떨어진다. */
.detail-page--top .page {
	right: 336px;
}

/* Weekly 저장 팝업. 콘솔 규칙(DESIGN.md): 파랑은 누르는 것에만, 상태는 배지가 아니라 잉크색 한 단어. */
.wk-pick__lead {
	margin: 2px 0 8px;
	font-size: 13px;
	color: #212529;
}
.wk-pick__hint {
	display: block;
	margin-top: 2px;
	font-size: 12px;
	color: #6c757d;
}
.wk-pick__notice {
	margin: 0 0 8px;
	font-size: 12px;
	font-weight: 600;
	color: #1a7f37;
}
.wk-pick__empty {
	padding: 18px 8px !important;
	text-align: center;
	color: #6c757d;
}
.wk-pick__title {
	text-align: left;
}
.wk-pick__owner {
	margin-left: 6px;
	font-size: 11.5px;
	color: #6c757d;
}
.wk-pick__pub {
	font-weight: 600;
	color: #1a7f37;
}
.wk-pick__draft {
	color: #6c757d;
}
.wk-pick__act {
	white-space: nowrap;
}
.wk-pick__act .btn + .btn {
	margin-left: 4px;
}
.wk-pick__in {
	margin-right: 6px;
	font-weight: 600;
	color: #212529;
}
.wk-pick__new {
	display: flex;
	gap: 8px;
	align-items: center;
}
.wk-pick__new .form-control {
	flex: 1;
}
</style>

<!-- F-3.5 제외 row 연회색 처리 스타일은 assets/css/common.scss 로 이동 (전역 단일 정의). -->
